import React from "react";

export default function HarvestFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-3har1{fill:#7baf42}.cls-3har2{fill:#ddbb2c}.cls-3har3{fill:#f2d33b}"
            }
          </style>
        </defs>
        <path
          d="M847.83 122.52c10.69-2.8 43.03 82.17 39.12 165.04-1.54 32.5-8.29 57.13-13.89 72.91-.51-11.85-1.76-30.94-5.43-53.94-8.5-53.31-20.83-70.46-24.9-113.56-2.66-28.15-1.92-68.61 5.1-70.45ZM978.38 128c10.69-2.8 43.03 82.17 39.12 165.04-1.54 32.5-8.29 57.13-13.89 72.91-.51-11.85-1.76-30.94-5.43-53.94-8.5-53.31-20.83-70.46-24.9-113.56-2.66-28.15-1.92-68.61 5.1-70.45ZM1045.62 129.23c7.25-9.2 52.29 8.36 69.89 51.5 6.9 16.92 7.98 33.84 7.73 45.62-3.31-5.38-8.97-13.74-17.38-22.23-19.5-19.67-32.9-18.96-46.59-36.91-8.94-11.73-18.4-31.93-13.64-37.98Z"
          className="cls-3har1"
        />
        <path
          d="M975.59 129.19c-9.04-8.34-48.32 8.89-55.44 49.12-2.79 15.78 0 31.43 2.92 42.29 1.96-5.05 5.5-12.89 11.65-20.91 14.27-18.6 27.3-18.24 36.37-35.13 5.93-11.03 10.43-29.9 4.5-35.37ZM1362.39 130.32c7.04-9.91 52.15 3.08 70.45 44.36 7.18 16.19 8.56 32.96 8.53 44.74-3.39-5.04-9.17-12.81-17.7-20.43-19.76-17.67-33.07-15.61-47.01-32.15-9.11-10.8-18.89-30.01-14.27-36.52ZM1247.71 117.26c-13.58-11.39-83.07 42.9-103.01 124.8-7.82 32.12-6.2 61.03-3.45 80.59 4.29-10.84 11.8-27.95 23.75-46.8 27.69-43.7 49.55-49.91 68.16-87.52 12.16-24.56 23.47-63.6 14.55-71.08Z"
          className="cls-3har1"
        />
        <path
          d="M1249.07 117.64c21.45-8.21 87.16 71.21 80.04 165.51-2.79 36.99-16.14 67.66-27.24 87.93-1.12-12.97-3.82-33.68-11.39-57.59-17.55-55.43-42.46-68.7-51.03-114.84-5.6-30.13-4.46-75.63 9.62-81.01ZM1556.53 122.61c-10.97-7.83-66 49.31-81.11 122.98-5.93 28.9-4.33 53.62-1.94 70.11 3.32-9.99 9.15-25.88 18.51-43.92 21.7-41.82 39.12-50.42 53.62-85.64 9.47-23 18.12-58.39 10.92-63.53Z"
          className="cls-3har1"
        />
        <path
          d="M1555.64 126.09c13.04-5.01 54.78 51.71 52.01 116.5-1.09 25.41-8.76 46.16-15.24 59.8-.91-8.98-2.92-23.33-7.98-40.04-11.73-38.74-27.27-48.63-33.32-80.7-3.95-20.94-4.03-52.27 4.53-55.56ZM676.24 125.32c10.41-4.4 51.95 74.42 56.93 156.73 1.95 32.28-2.17 57.6-6.08 74.03-1.78-11.6-5.09-30.24-11.24-52.36-14.24-51.27-28.44-66.28-37.15-108.15-5.69-27.35-9.29-67.36-2.46-70.25ZM511.19 128.92c-8.95-11.38-80.77 31.63-116.69 103.62-14.09 28.23-19.38 54.36-21.56 72.18 6.16-9.39 16.52-24.15 31.06-40.1 33.71-36.98 53.79-40.74 78.35-73 16.04-21.07 34.71-55.23 28.83-62.7Z"
          className="cls-3har1"
        />
        <path
          d="M504.32 127.9c12.38-5.44 57.77 61.63 60.21 136.77.95 29.47-4.92 53.33-10.18 68.98-1.61-10.45-4.72-27.17-11-46.72-14.57-45.32-30.57-57.26-39.05-94.66-5.53-24.43-8.1-60.8.03-64.37ZM672.27 127.55c-10.35-2.25-37.69 54.61-30.42 111.21 2.85 22.2 10.37 39.2 16.39 50.13-.02-8.06.37-21.03 2.9-36.59 5.87-36.06 16.94-47.35 19-76.58 1.35-19.1-1.08-46.69-7.88-48.17ZM843.29 118.65c-9.01-6.35-51.81 35.67-62.15 91.62-4.05 21.94-2.17 40.93.16 53.64 2.42-7.55 6.72-19.53 13.8-33.05 16.41-31.35 30.19-37.38 40.98-63.89 7.04-17.32 13.13-44.15 7.21-48.31ZM614.33 120.31c-10.35-2.25-37.69 54.61-30.42 111.21 2.85 22.2 10.37 39.2 16.39 50.13-.02-8.06.37-21.03 2.9-36.59 5.87-36.06 16.94-47.35 19-76.58 1.35-19.1-1.08-46.69-7.88-48.17Z"
          className="cls-3har1"
        />
        <path
          d="M1574.7 1883.21H425.3c-55.89 0-101.36-45.47-101.36-101.36V216.23c0-55.89 45.47-101.36 101.36-101.36h1149.41c55.89 0 101.36 45.47 101.36 101.36v1565.63c0 55.89-45.47 101.36-101.36 101.36ZM425.3 138.87c-42.65 0-77.36 34.7-77.36 77.36v1565.63c0 42.65 34.7 77.36 77.36 77.36h1149.41c42.65 0 77.36-34.7 77.36-77.36V216.23c0-42.65-34.7-77.36-77.36-77.36H425.3Z"
          className="cls-3har1"
        />
        <path
          d="M472.43 327.73c-8.99 1.78-13.11 6.38-15.16 9.8-9.99 16.66-.37 54.43 26.84 91.87 18.7-40.08 19.61-78.67 6-93.88-2.77-3.1-8.01-7.31-17.68-7.79Z"
          className="cls-3har3"
        />
        <path
          d="M499.37 367.09c-1.32-7.83-3.57-14.27-6.67-18.78-2.18-3.17-6.25-7.54-13.52-8.33-6.68 1.48-9.61 5.92-11.03 9.26-6.15 14.42-.19 45.86 16.32 79.42-.12.25-.23.51-.35.75-27.21-37.45-36.84-75.21-26.84-91.87 2.05-3.41 6.16-8.02 15.16-9.79 9.67.49 14.91 4.69 17.68 7.79 5.95 6.66 9.13 17.78 9.25 31.56Z"
          className="cls-3har2"
        />
        <path
          d="M490.43 273.33c-6.74 4.18-8.65 9.16-9.26 12.55-2.95 16.53 16.52 44.2 50.13 66.26 2.77-38.16-8.42-69.69-24.14-77.87-3.2-1.67-8.75-3.48-16.73-.93Z"
          className="cls-3har3"
        />
        <path
          d="M531.7 348.24c-.57-31.53-10.83-56.41-24.53-63.54-3.2-1.67-8.75-3.48-16.74-.93-5.61 3.48-7.88 7.52-8.82 10.74-.63-3.11-.73-6-.26-8.62.61-3.39 2.52-8.37 9.26-12.55 7.98-2.55 13.53-.73 16.73.93 15.18 7.91 26.14 37.59 24.36 73.98Z"
          className="cls-3har2"
        />
        <path
          d="M496.79 203.48c-6.76 4.14-8.7 9.11-9.32 12.5-3.04 16.52 16.28 44.29 49.77 66.52 2.97-38.14-8.05-69.74-23.72-78-3.19-1.68-8.73-3.53-16.73-1.02Z"
          className="cls-3har3"
        />
        <path
          d="M537.25 282.51c-.45-.3-.89-.6-1.33-.89-.14-32.15-10.35-57.66-24.21-64.96-3.19-1.69-8.72-3.53-16.73-1.02-3.89 2.38-6.19 5.05-7.55 7.52-.37-2.57-.37-4.97.04-7.17.63-3.38 2.57-8.35 9.33-12.5 8-2.5 13.53-.65 16.72 1.02 15.68 8.27 26.7 39.87 23.73 78.01Z"
          className="cls-3har2"
        />
        <path
          d="M513.06 146c-6.58 4.41-8.32 9.45-8.8 12.86-2.36 16.62 18.08 43.59 52.46 64.46 1.41-38.23-10.9-69.35-26.9-76.98-3.26-1.55-8.86-3.17-16.76-.35Z"
          className="cls-3har3"
        />
        <path
          d="M556.72 223.33c-.17-.1-.34-.21-.51-.31-5.71-37.51-23.38-65.59-40.41-70.18-2.23-.6-5.41-1.05-9.32-.21 1.32-2.18 3.38-4.48 6.58-6.63 7.89-2.83 13.5-1.21 16.76.35 16 7.62 28.31 38.75 26.9 76.98Z"
          className="cls-3har2"
        />
        <path
          d="M452.78 290.25c6.51 4.51 8.17 9.58 8.6 13 2.1 16.66-18.76 43.31-53.47 63.64-.81-38.25 11.99-69.18 28.11-76.55 3.28-1.5 8.91-3.04 16.76-.09Z"
          className="cls-3har3"
        />
        <path
          d="M461.43 303.7c-1.29-1.94-3.18-3.95-5.93-5.85-7.84-2.95-13.48-1.41-16.76.09-14.79 6.77-26.79 33.38-28.03 67.28-.92.56-1.86 1.11-2.8 1.67-.8-38.24 11.99-69.18 28.11-76.55 3.28-1.5 8.91-3.04 16.76-.09 6.51 4.51 8.17 9.59 8.6 13 .02.15.04.31.05.46Z"
          className="cls-3har2"
        />
        <path
          d="M463.2 233.48c4.75 6.32 4.72 11.65 4.04 15.02-3.29 16.47-31.55 35.25-70.93 43.71 11.36-36.55 33.32-61.92 50.96-63.89 3.59-.4 9.42-.1 15.94 5.15Z"
          className="cls-3har3"
        />
        <path
          d="M467.25 248.51c-.35 1.73-.97 3.48-1.85 5.24-.35-2.8-1.5-6.11-4.24-9.75-6.51-5.26-12.34-5.56-15.93-5.16-15.83 1.78-35.13 22.37-47.14 52.99-.59.14-1.18.27-1.78.4 11.37-36.55 33.32-61.93 50.96-63.89 3.59-.4 9.42-.1 15.94 5.15 4.75 6.32 4.71 11.65 4.04 15.02Z"
          className="cls-3har2"
        />
        <path
          d="M477.85 167.8c3.96 6.83 3.28 12.12 2.2 15.39-5.25 15.96-35.57 31.26-75.69 34.99 15.69-34.94 40.54-57.52 58.29-57.39 3.61.03 9.37 1.02 15.2 7Z"
          className="cls-3har3"
        />
        <path
          d="M480.05 183.2c-.47 1.42-1.13 2.84-1.98 4.24.33-3.12-.16-7.15-2.94-11.97-5.84-5.99-11.59-6.98-15.2-7.01-16.4-.13-38.87 19.14-54.56 49.62-.33.04-.67.07-1.01.1 15.69-34.95 40.54-57.53 58.29-57.39 3.61.03 9.37 1.02 15.2 7 3.96 6.84 3.28 12.13 2.2 15.4Z"
          className="cls-3har2"
        />
        <path
          d="M471.06 316.59c-1.69 0-3.08-1.36-3.11-3.06-.53-31.41 2.28-62.94 8.35-93.74 6.65-33.76 17.25-66.8 31.49-98.2a3.107 3.107 0 0 1 4.12-1.55c1.57.71 2.26 2.55 1.55 4.12a441.767 441.767 0 0 0-31.05 96.83 440.897 440.897 0 0 0-8.24 92.43 3.101 3.101 0 0 1-3.06 3.16h-.05Z"
          className="cls-3har1"
        />
        <path
          d="M648.22 370.45c10.09 2.06 14.72 7.4 17.02 11.36 11.21 19.31.41 63.12-30.13 106.54-20.99-46.48-22.01-91.23-6.74-108.87 3.11-3.59 8.99-8.47 19.85-9.04Z"
          className="cls-3har3"
        />
        <path
          d="M617.99 416.09c1.48-9.08 4.01-16.55 7.49-21.78 2.45-3.68 7.01-8.74 15.17-9.67 7.5 1.71 10.79 6.87 12.38 10.74 6.9 16.72.21 53.18-18.32 92.1.13.29.26.59.39.87 30.54-43.43 41.35-87.22 30.13-106.54-2.3-3.96-6.91-9.3-17.02-11.36-10.85.56-16.74 5.44-19.84 9.03-6.68 7.72-10.25 20.62-10.38 36.6Z"
          className="cls-3har2"
        />
        <path
          d="M628.02 307.36c7.56 4.84 9.71 10.62 10.39 14.55 3.31 19.17-18.54 51.26-56.27 76.84-3.11-44.25 9.45-80.82 27.1-90.31 3.59-1.93 9.82-4.04 18.78-1.08Z"
          className="cls-3har3"
        />
        <path
          d="M581.7 394.24c.64-36.57 12.16-65.42 27.53-73.69 3.59-1.93 9.82-4.04 18.79-1.08 6.3 4.04 8.84 8.72 9.9 12.45.71-3.6.82-6.96.29-10-.68-3.94-2.83-9.71-10.39-14.56-8.96-2.96-15.19-.85-18.78 1.08-17.04 9.17-29.34 43.59-27.34 85.79Z"
          className="cls-3har2"
        />
        <path
          d="M620.88 226.36c7.59 4.8 9.76 10.57 10.46 14.49 3.41 19.15-18.27 51.36-55.87 77.15-3.34-44.23 9.03-80.87 26.63-90.46 3.58-1.95 9.79-4.09 18.78-1.19Z"
          className="cls-3har3"
        />
        <path
          d="M575.47 318c.51-.35 1-.69 1.49-1.04.16-37.28 11.62-66.87 27.17-75.33 3.58-1.96 9.79-4.1 18.78-1.19 4.37 2.76 6.95 5.86 8.47 8.72.41-2.98.41-5.76-.04-8.32-.71-3.92-2.88-9.69-10.47-14.5-8.98-2.9-15.19-.76-18.77 1.19-17.6 9.59-29.97 46.23-26.63 90.47Z"
          className="cls-3har2"
        />
        <path
          d="M602.62 159.7c7.39 5.11 9.34 10.96 9.88 14.92 2.65 19.28-20.3 50.55-58.88 74.75-1.58-44.33 12.24-80.43 30.2-89.27 3.66-1.8 9.95-3.68 18.81-.4Z"
          className="cls-3har3"
        />
        <path
          d="m553.62 249.38.57-.36c6.41-43.5 26.24-76.06 45.36-81.39 2.5-.69 6.07-1.22 10.46-.24-1.48-2.53-3.79-5.2-7.39-7.69-8.86-3.28-15.15-1.4-18.81.4-17.96 8.84-31.78 44.93-30.19 89.27Z"
          className="cls-3har2"
        />
        <path
          d="M670.28 326.98c-7.31 5.23-9.17 11.11-9.65 15.07-2.35 19.32 21.06 50.22 60.01 73.8.91-44.35-13.45-80.22-31.55-88.78-3.68-1.74-10-3.52-18.81-.1Z"
          className="cls-3har3"
        />
        <path
          d="M660.57 342.58c1.45-2.26 3.57-4.58 6.66-6.79 8.8-3.42 15.13-1.63 18.81.1 16.6 7.85 30.07 38.71 31.46 78.03 1.03.64 2.09 1.29 3.14 1.93.9-44.35-13.46-80.23-31.55-88.77-3.68-1.74-10-3.52-18.81-.1-7.31 5.24-9.17 11.12-9.65 15.07l-.06.53Z"
          className="cls-3har2"
        />
        <path
          d="M658.58 261.15c-5.33 7.32-5.29 13.51-4.53 17.42 3.7 19.1 35.41 40.88 79.62 50.69-12.76-42.39-37.4-71.81-57.19-74.09-4.03-.46-10.58-.12-17.89 5.97Z"
          className="cls-3har3"
        />
        <path
          d="M654.04 278.57c.39 2 1.09 4.04 2.08 6.08.39-3.24 1.68-7.09 4.76-11.31 7.31-6.1 13.85-6.44 17.88-5.98 17.77 2.06 39.43 25.95 52.91 61.46.66.16 1.32.31 2 .46-12.76-42.39-37.4-71.81-57.2-74.09-4.03-.46-10.57-.12-17.89 5.97-5.33 7.33-5.29 13.51-4.53 17.42Z"
          className="cls-3har2"
        />
        <path
          d="M642.14 184.98c-4.44 7.92-3.68 14.06-2.47 17.85 5.9 18.51 39.92 36.25 84.96 40.57-17.61-40.52-45.5-66.71-65.42-66.55-4.06.03-10.51 1.18-17.06 8.12Z"
          className="cls-3har3"
        />
        <path
          d="M639.67 202.83c.53 1.65 1.27 3.29 2.22 4.91-.37-3.61.18-8.3 3.3-13.88 6.55-6.95 13.01-8.09 17.06-8.12 18.41-.15 43.63 22.2 61.24 57.55.37.05.75.08 1.13.12-17.61-40.53-45.5-66.72-65.42-66.55-4.05.03-10.52 1.18-17.06 8.12-4.44 7.93-3.68 14.06-2.47 17.86Z"
          className="cls-3har2"
        />
        <path
          d="M649.76 357.48h-.06a3.551 3.551 0 0 1-3.49-3.61c.58-35.92-2.53-72-9.25-107.23a525.026 525.026 0 0 0-34.86-112.33c-.79-1.8.03-3.89 1.82-4.68 1.8-.79 3.89.03 4.68 1.82a531.723 531.723 0 0 1 35.34 113.85c6.81 35.7 9.96 72.26 9.37 108.67a3.545 3.545 0 0 1-3.55 3.49Z"
          className="cls-3har1"
        />
        <path
          d="M813.48 349.67c-7.88 1.86-11.48 6.65-13.28 10.22-8.75 17.37-.32 56.77 23.51 95.83 16.38-41.8 17.17-82.06 5.26-97.92-2.43-3.23-7.01-7.62-15.49-8.13Z"
          className="cls-3har3"
        />
        <path
          d="M837.07 390.72c-1.16-8.17-3.13-14.88-5.84-19.59-1.91-3.31-5.47-7.87-11.84-8.69-5.85 1.54-8.42 6.18-9.66 9.66-5.39 15.04-.17 47.83 14.29 82.84-.1.26-.2.53-.31.79-23.83-39.06-32.26-78.45-23.51-95.82 1.8-3.56 5.39-8.36 13.28-10.21 8.47.51 13.06 4.89 15.48 8.12 5.21 6.94 8 18.55 8.1 32.92Z"
          className="cls-3har2"
        />
        <path
          d="M829.24 292.93c-5.9 4.36-7.58 9.55-8.11 13.09-2.58 17.24 14.47 46.1 43.9 69.11 2.42-39.8-7.38-72.69-21.14-81.22-2.8-1.74-7.66-3.63-14.65-.97Z"
          className="cls-3har3"
        />
        <path
          d="M865.38 371.07c-.5-32.89-9.48-58.84-21.48-66.28-2.8-1.74-7.66-3.63-14.66-.97-4.91 3.63-6.9 7.84-7.72 11.2-.55-3.24-.64-6.26-.23-8.99.53-3.54 2.21-8.73 8.11-13.09 6.99-2.66 11.85-.77 14.65.97 13.29 8.25 22.89 39.2 21.33 77.16Z"
          className="cls-3har2"
        />
        <path
          d="M834.81 220.08c-5.92 4.32-7.62 9.5-8.16 13.04-2.66 17.23 14.26 46.19 43.59 69.39 2.6-39.78-7.05-72.74-20.77-81.36-2.8-1.75-7.64-3.68-14.65-1.07Z"
          className="cls-3har3"
        />
        <path
          d="M870.24 302.5c-.39-.31-.78-.62-1.16-.93-.12-33.53-9.06-60.14-21.2-67.76-2.79-1.76-7.64-3.68-14.65-1.07-3.41 2.48-5.42 5.27-6.61 7.84-.32-2.68-.32-5.18.04-7.48.55-3.53 2.25-8.71 8.17-13.04 7.01-2.61 11.85-.68 14.64 1.07 13.73 8.62 23.38 41.58 20.78 81.37Z"
          className="cls-3har2"
        />
        <path
          d="M849.06 160.13c-5.76 4.6-7.29 9.86-7.71 13.42-2.06 17.34 15.84 45.47 45.94 67.23 1.23-39.87-9.55-72.34-23.56-80.29-2.85-1.62-7.76-3.31-14.67-.36Z"
          className="cls-3har3"
        />
        <path
          d="M887.29 240.78c-.15-.1-.3-.22-.45-.32-5-39.12-20.48-68.41-35.39-73.2-1.95-.62-4.74-1.1-8.16-.22 1.16-2.28 2.96-4.68 5.76-6.91 6.91-2.95 11.82-1.26 14.68.36 14.01 7.95 24.79 40.41 23.56 80.29Z"
          className="cls-3har2"
        />
        <path
          d="M796.27 310.58c5.7 4.71 7.15 9.99 7.53 13.56 1.84 17.38-16.43 45.17-46.82 66.38-.71-39.89 10.5-72.15 24.61-79.85 2.87-1.57 7.81-3.17 14.68-.09Z"
          className="cls-3har3"
        />
        <path
          d="M803.84 324.61c-1.13-2.03-2.78-4.12-5.19-6.11-6.87-3.07-11.81-1.47-14.68.09-12.95 7.06-23.46 34.81-24.55 70.18-.81.58-1.63 1.16-2.45 1.74-.7-39.89 10.5-72.15 24.62-79.84 2.87-1.56 7.8-3.17 14.68-.09 5.7 4.71 7.15 10 7.53 13.56.02.16.04.32.04.48Z"
          className="cls-3har2"
        />
        <path
          d="M805.4 251.37c4.16 6.59 4.13 12.15 3.54 15.67-2.88 17.18-27.63 36.77-62.12 45.59 9.95-38.13 29.18-64.58 44.63-66.64 3.15-.42 8.25-.1 13.96 5.37Z"
          className="cls-3har3"
        />
        <path
          d="M808.94 267.04c-.31 1.8-.85 3.63-1.62 5.46-.31-2.92-1.31-6.38-3.71-10.17-5.7-5.48-10.81-5.8-13.95-5.38-13.86 1.85-30.77 23.34-41.28 55.27-.52.15-1.03.28-1.56.41 9.96-38.13 29.18-64.59 44.63-66.64 3.14-.41 8.25-.1 13.96 5.37 4.16 6.59 4.12 12.15 3.54 15.67Z"
          className="cls-3har2"
        />
        <path
          d="M818.22 182.86c3.46 7.13 2.87 12.64 1.93 16.06-4.6 16.64-31.15 32.6-66.29 36.49 13.74-36.45 35.5-60 51.05-59.85 3.17.03 8.2 1.06 13.31 7.3Z"
          className="cls-3har3"
        />
        <path
          d="M820.15 198.92c-.41 1.48-.99 2.96-1.73 4.42.29-3.25-.14-7.46-2.57-12.48-5.11-6.25-10.15-7.28-13.31-7.31-14.36-.13-34.04 19.96-47.78 51.76-.29.04-.59.07-.88.1 13.74-36.45 35.5-60 51.05-59.86 3.16.03 8.21 1.07 13.31 7.31 3.47 7.13 2.87 12.65 1.93 16.06Z"
          className="cls-3har2"
        />
        <path
          d="M812.28 337.78c-1.62 0-2.95-1.3-2.97-2.93-.46-32.7 2-65.55 7.3-97.62 5.82-35.16 15.08-69.57 27.54-102.29.58-1.54 2.3-2.31 3.84-1.72 1.54.58 2.31 2.3 1.72 3.84-12.32 32.34-21.48 66.37-27.23 101.14-5.25 31.72-7.68 64.21-7.23 96.56a2.986 2.986 0 0 1-2.93 3.02h-.04Z"
          className="cls-3har1"
        />
        <path
          d="M955.17 286.1c-5.46 1.29-7.97 4.62-9.21 7.09-6.07 12.05-.22 39.38 16.31 66.48 11.36-29 11.91-56.92 3.65-67.93-1.68-2.24-4.87-5.29-10.74-5.64Z"
          className="cls-3har3"
        />
        <path
          d="M971.53 314.58c-.8-5.66-2.17-10.32-4.05-13.59-1.32-2.3-3.8-5.46-8.21-6.03-4.06 1.07-5.84 4.29-6.7 6.7-3.74 10.43-.12 33.18 9.91 57.47-.07.18-.14.37-.21.55-16.53-27.1-22.38-54.42-16.31-66.48 1.25-2.47 3.74-5.8 9.21-7.09 5.87.35 9.06 3.4 10.74 5.64 3.61 4.82 5.55 12.87 5.62 22.84Z"
          className="cls-3har2"
        />
        <path
          d="M966.1 246.74c-4.09 3.02-5.26 6.63-5.62 9.08-1.79 11.96 10.04 31.98 30.46 47.94 1.68-27.61-5.12-50.43-14.67-56.35-1.94-1.21-5.31-2.52-10.17-.68Z"
          className="cls-3har3"
        />
        <path
          d="M991.17 300.94c-.35-22.82-6.58-40.82-14.9-45.98-1.94-1.21-5.32-2.52-10.17-.67-3.41 2.52-4.79 5.44-5.36 7.77-.38-2.25-.44-4.34-.16-6.24.37-2.46 1.53-6.06 5.63-9.08 4.85-1.85 8.22-.53 10.16.67 9.22 5.72 15.88 27.2 14.8 53.53Z"
          className="cls-3har2"
        />
        <path
          d="M969.97 196.2c-4.11 3-5.29 6.59-5.66 9.04-1.85 11.95 9.89 32.05 30.24 48.14 1.81-27.6-4.89-50.46-14.41-56.44-1.94-1.22-5.3-2.55-10.16-.74Z"
          className="cls-3har3"
        />
        <path
          d="M994.54 253.38c-.27-.22-.54-.43-.81-.65-.09-23.26-6.29-41.72-14.71-47-1.94-1.22-5.3-2.56-10.16-.74-2.36 1.72-3.76 3.65-4.59 5.44-.22-1.86-.22-3.6.02-5.19.38-2.45 1.56-6.05 5.67-9.05 4.86-1.81 8.22-.47 10.16.74 9.53 5.98 16.22 28.85 14.42 56.45Z"
          className="cls-3har2"
        />
        <path
          d="M979.85 154.61c-4 3.19-5.05 6.84-5.35 9.31-1.43 12.03 10.99 31.54 31.87 46.64.85-27.66-6.62-50.18-16.34-55.7-1.98-1.12-5.39-2.3-10.18-.25Z"
          className="cls-3har3"
        />
        <path
          d="m1006.37 210.56-.31-.22c-3.47-27.14-14.2-47.46-24.55-50.78-1.35-.43-3.29-.76-5.66-.15.8-1.58 2.05-3.25 4-4.8 4.79-2.05 8.2-.88 10.18.25 9.72 5.51 17.2 28.04 16.34 55.7Z"
          className="cls-3har2"
        />
        <path
          d="M943.22 258.98c3.96 3.26 4.96 6.93 5.22 9.41 1.27 12.05-11.4 31.34-32.48 46.05-.49-27.67 7.28-50.06 17.08-55.39 1.99-1.09 5.41-2.2 10.18-.06Z"
          className="cls-3har3"
        />
        <path
          d="M948.48 268.71c-.78-1.41-1.93-2.86-3.6-4.24-4.76-2.13-8.19-1.02-10.18.06-8.99 4.9-16.28 24.15-17.03 48.68-.56.4-1.13.8-1.7 1.21-.49-27.67 7.28-50.06 17.08-55.39 1.99-1.08 5.41-2.2 10.18-.06 3.96 3.27 4.96 6.94 5.22 9.41l.03.33Z"
          className="cls-3har2"
        />
        <path
          d="M949.56 217.9c2.89 4.57 2.86 8.43 2.45 10.87-2 11.92-19.17 25.51-43.1 31.63 6.9-26.45 20.24-44.8 30.96-46.23 2.18-.29 5.73-.07 9.68 3.73Z"
          className="cls-3har3"
        />
        <path
          d="M952.02 228.77c-.21 1.25-.59 2.52-1.12 3.79-.21-2.02-.91-4.42-2.58-7.06-3.96-3.81-7.5-4.02-9.68-3.73-9.62 1.29-21.34 16.19-28.64 38.35-.36.1-.72.19-1.08.29 6.91-26.45 20.24-44.81 30.96-46.23 2.18-.29 5.72-.07 9.68 3.73 2.89 4.57 2.86 8.43 2.45 10.87Z"
          className="cls-3har2"
        />
        <path
          d="M958.46 170.38c2.4 4.94 1.99 8.77 1.34 11.14-3.19 11.55-21.61 22.62-45.99 25.32 9.53-25.29 24.63-41.62 35.41-41.52 2.2.02 5.69.74 9.24 5.07Z"
          className="cls-3har3"
        />
        <path
          d="M959.79 181.52a17.4 17.4 0 0 1-1.2 3.07c.2-2.25-.1-5.18-1.79-8.66-3.55-4.34-7.04-5.05-9.23-5.07-9.96-.09-23.61 13.85-33.15 35.91-.2.03-.41.05-.61.07 9.53-25.29 24.63-41.63 35.41-41.53 2.19.02 5.69.74 9.23 5.07 2.41 4.95 1.99 8.77 1.34 11.14Z"
          className="cls-3har2"
        />
        <path
          d="M954.33 277.85c-1.13 0-2.05-.9-2.06-2.03a382.99 382.99 0 0 1 5.07-67.72c4.04-24.39 10.46-48.27 19.11-70.96.41-1.06 1.6-1.6 2.66-1.19 1.06.41 1.6 1.6 1.19 2.66-8.54 22.44-14.9 46.04-18.89 70.16a378.53 378.53 0 0 0-5.01 66.99c.02 1.14-.89 2.08-2.03 2.09h-.03Z"
          className="cls-3har1"
        />
        <path
          d="M1071.01 324.41c6.12 1.68 8.92 6.01 10.32 9.23 6.8 15.7.25 51.3-18.27 86.59-12.73-37.77-13.35-74.15-4.08-88.48 1.89-2.92 5.45-6.89 12.04-7.35Z"
          className="cls-3har3"
        />
        <path
          d="M1052.68 361.51c.9-7.38 2.43-13.45 4.54-17.7 1.48-2.99 4.25-7.11 9.2-7.86 4.55 1.39 6.54 5.58 7.51 8.73 4.19 13.59.13 43.22-11.11 74.85.08.23.16.48.24.71 18.52-35.29 25.08-70.89 18.27-86.59-1.4-3.22-4.19-7.56-10.32-9.23-6.58.46-10.15 4.42-12.03 7.34-4.05 6.27-6.21 16.76-6.3 29.75Z"
          className="cls-3har2"
        />
        <path
          d="M1058.76 273.14c4.58 3.94 5.89 8.63 6.3 11.83 2.01 15.58-11.24 41.66-34.12 62.45-1.88-35.96 5.73-65.69 16.43-73.39 2.18-1.57 5.95-3.28 11.39-.88Z"
          className="cls-3har3"
        />
        <path
          d="M1030.67 343.75c.39-29.72 7.37-53.16 16.7-59.89 2.18-1.57 5.96-3.28 11.39-.88 3.82 3.28 5.36 7.09 6 10.12.43-2.93.5-5.66.18-8.13-.42-3.2-1.72-7.89-6.3-11.83-5.43-2.4-9.21-.69-11.39.88-10.33 7.45-17.79 35.42-16.58 69.73Z"
          className="cls-3har2"
        />
        <path
          d="M1054.43 207.31c4.6 3.9 5.92 8.59 6.35 11.78 2.07 15.57-11.08 41.74-33.88 62.7-2.02-35.95 5.48-65.73 16.15-73.51 2.17-1.59 5.94-3.33 11.39-.96Z"
          className="cls-3har3"
        />
        <path
          d="M1026.9 281.79c.31-.28.61-.56.91-.84.1-30.3 7.04-54.34 16.48-61.23 2.17-1.59 5.94-3.33 11.39-.96 2.65 2.24 4.21 4.76 5.14 7.09.25-2.42.25-4.68-.03-6.76-.43-3.19-1.75-7.87-6.35-11.78-5.45-2.36-9.21-.62-11.38.96-10.67 7.79-18.17 37.57-16.15 73.52Z"
          className="cls-3har2"
        />
        <path
          d="M1043.36 153.14c4.48 4.16 5.66 8.91 5.99 12.12 1.6 15.67-12.31 41.09-35.71 60.75-.96-36.03 7.42-65.37 18.31-72.55 2.22-1.46 6.03-2.99 11.41-.33Z"
          className="cls-3har3"
        />
        <path
          d="M1013.64 226.02c.12-.09.23-.2.35-.29 3.89-35.35 15.91-61.81 27.51-66.14 1.52-.56 3.68-.99 6.34-.2-.9-2.06-2.3-4.23-4.48-6.25-5.37-2.66-9.19-1.14-11.41.33-10.89 7.18-19.27 36.52-18.31 72.55Z"
          className="cls-3har2"
        />
        <path
          d="M1084.39 289.09c-4.43 4.25-5.56 9.03-5.85 12.25-1.43 15.7 12.77 40.82 36.39 59.98.55-36.05-8.16-65.2-19.13-72.15-2.23-1.42-6.07-2.86-11.41-.08Z"
          className="cls-3har3"
        />
        <path
          d="M1078.5 301.77c.88-1.83 2.16-3.72 4.04-5.52 5.34-2.78 9.18-1.33 11.41.08 10.07 6.38 18.23 31.46 19.08 63.41.63.52 1.27 1.05 1.91 1.57.54-36.04-8.16-65.2-19.13-72.15-2.23-1.41-6.06-2.86-11.41-.08-4.43 4.25-5.56 9.03-5.85 12.25-.01.14-.03.29-.03.43Z"
          className="cls-3har2"
        />
        <path
          d="M1077.29 235.59c-3.23 5.95-3.21 10.98-2.75 14.16 2.24 15.52 21.47 33.22 48.28 41.2-7.74-34.45-22.68-58.36-34.68-60.21-2.44-.38-6.41-.09-10.85 4.85Z"
          className="cls-3har3"
        />
        <path
          d="M1074.54 249.74c.24 1.63.66 3.28 1.26 4.94.24-2.64 1.02-5.76 2.89-9.19 4.43-4.96 8.4-5.24 10.84-4.86 10.77 1.67 23.91 21.09 32.09 49.95.4.13.8.25 1.21.37-7.74-34.45-22.68-58.36-34.69-60.22-2.44-.37-6.41-.09-10.85 4.85-3.23 5.96-3.21 10.98-2.75 14.16Z"
          className="cls-3har2"
        />
        <path
          d="M1067.33 173.68c-2.69 6.44-2.23 11.42-1.5 14.51 3.58 15.04 24.21 29.46 51.52 32.98-10.68-32.93-27.59-54.22-39.67-54.09-2.46.03-6.38.96-10.35 6.6Z"
          className="cls-3har3"
        />
        <path
          d="M1065.83 188.19c.32 1.34.77 2.67 1.35 3.99-.22-2.94.11-6.74 2-11.28 3.97-5.65 7.89-6.57 10.35-6.6 11.16-.12 26.46 18.04 37.14 46.77.22.04.46.07.69.09-10.68-32.94-27.59-54.22-39.67-54.09-2.46.03-6.38.96-10.35 6.6-2.7 6.44-2.23 11.43-1.5 14.51Z"
          className="cls-3har2"
        />
        <path
          d="M1071.94 313.48h-.03a2.49 2.49 0 0 1-2.46-2.52c.35-29.27-1.54-58.65-5.62-87.35-4.48-31.45-11.6-62.23-21.19-91.48a2.48 2.48 0 0 1 1.59-3.14 2.48 2.48 0 0 1 3.14 1.59c9.67 29.53 16.87 60.59 21.38 92.33 4.12 28.95 6.03 58.59 5.67 88.11a2.49 2.49 0 0 1-2.49 2.46Z"
          className="cls-3har1"
        />
        <path
          d="M1214.72 384.44c-8.81 2.18-12.85 7.8-14.86 11.98-9.79 20.37-.36 66.55 26.3 112.35 18.32-49.01 19.21-96.2 5.88-114.8-2.71-3.79-7.85-8.94-17.33-9.53Z"
          className="cls-3har3"
        />
        <path
          d="M1241.11 432.57c-1.29-9.57-3.5-17.45-6.54-22.97-2.14-3.88-6.12-9.22-13.25-10.19-6.54 1.81-9.42 7.24-10.81 11.32-6.03 17.63-.19 56.08 15.99 97.12-.12.3-.23.62-.34.92-26.66-45.79-36.1-91.97-26.3-112.34 2.01-4.17 6.04-9.8 14.85-11.98 9.47.59 14.61 5.74 17.32 9.52 5.83 8.14 8.95 21.74 9.06 38.6Z"
          className="cls-3har2"
        />
        <path
          d="M1232.35 317.92c-6.6 5.11-8.48 11.2-9.07 15.34-2.89 20.22 16.18 54.05 49.12 81.03 2.71-46.66-8.25-85.22-23.65-95.23-3.14-2.04-8.57-4.26-16.4-1.14Z"
          className="cls-3har3"
        />
        <path
          d="M1272.78 409.53c-.56-38.56-10.61-68.98-24.03-77.7-3.14-2.04-8.57-4.26-16.4-1.14-5.5 4.26-7.72 9.2-8.64 13.13-.62-3.8-.72-7.34-.25-10.54.6-4.15 2.47-10.24 9.07-15.35 7.82-3.12 13.26-.9 16.39 1.14 14.87 9.67 25.61 45.96 23.87 90.47Z"
          className="cls-3har2"
        />
        <path
          d="M1238.58 232.51c-6.62 5.06-8.52 11.14-9.13 15.28-2.98 20.2 15.95 54.16 48.77 81.35 2.91-46.64-7.88-85.28-23.24-95.38-3.13-2.06-8.55-4.32-16.39-1.25Z"
          className="cls-3har3"
        />
        <path
          d="M1278.22 329.14c-.44-.36-.87-.73-1.3-1.09-.14-39.31-10.14-70.51-23.72-79.44-3.13-2.06-8.54-4.32-16.39-1.25-3.81 2.91-6.06 6.18-7.4 9.2-.36-3.14-.36-6.08.04-8.77.62-4.14 2.52-10.22 9.14-15.29 7.84-3.06 13.26-.8 16.38 1.25 15.36 10.11 26.16 48.75 23.25 95.39Z"
          className="cls-3har2"
        />
        <path
          d="M1254.52 162.22c-6.45 5.39-8.15 11.56-8.62 15.73-2.31 20.33 17.72 53.31 51.4 78.82 1.38-46.75-10.68-84.81-26.36-94.13-3.19-1.9-8.69-3.88-16.42-.42Z"
          className="cls-3har3"
        />
        <path
          d="M1297.3 256.78c-.17-.12-.33-.25-.5-.38-5.59-45.86-22.91-80.2-39.59-85.82-2.18-.73-5.3-1.29-9.13-.25 1.29-2.67 3.31-5.48 6.45-8.11 7.73-3.46 13.23-1.48 16.42.42 15.68 9.32 27.74 47.38 26.36 94.13Z"
          className="cls-3har2"
        />
        <path
          d="M1195.46 338.61c6.38 5.52 8 11.72 8.43 15.9 2.05 20.37-18.39 52.96-52.39 77.82-.79-46.77 11.74-84.59 27.54-93.61 3.22-1.84 8.73-3.71 16.42-.11Z"
          className="cls-3har3"
        />
        <path
          d="M1203.93 355.06c-1.26-2.38-3.12-4.83-5.81-7.16-7.68-3.6-13.21-1.72-16.42.11-14.49 8.28-26.25 40.82-27.46 82.28-.9.68-1.82 1.36-2.74 2.04-.78-46.76 11.75-84.59 27.54-93.61 3.21-1.83 8.73-3.71 16.42-.11 6.38 5.52 8 11.72 8.43 15.89.02.18.04.38.05.56Z"
          className="cls-3har2"
        />
        <path
          d="M1205.67 269.19c4.65 7.72 4.62 14.24 3.96 18.37-3.23 20.14-30.91 43.1-69.5 53.45 11.13-44.7 32.65-75.72 49.93-78.12 3.52-.49 9.23-.12 15.61 6.3Z"
          className="cls-3har3"
        />
        <path
          d="M1209.63 287.56c-.34 2.11-.95 4.26-1.81 6.41-.34-3.42-1.47-7.47-4.15-11.93-6.38-6.43-12.09-6.79-15.61-6.31-15.51 2.17-34.42 27.36-46.19 64.8-.58.17-1.16.33-1.74.49 11.14-44.7 32.65-75.72 49.93-78.13 3.52-.49 9.23-.12 15.62 6.3 4.65 7.73 4.61 14.24 3.96 18.37Z"
          className="cls-3har2"
        />
        <path
          d="M1220.02 188.87c3.88 8.36 3.21 14.82 2.16 18.83-5.15 19.51-34.85 38.22-74.16 42.78 15.37-42.73 39.72-70.34 57.11-70.17 3.54.03 9.18 1.24 14.89 8.56Z"
          className="cls-3har3"
        />
        <path
          d="M1222.18 207.7c-.46 1.74-1.11 3.47-1.94 5.18.32-3.81-.16-8.75-2.88-14.63-5.72-7.33-11.36-8.53-14.89-8.57-16.07-.16-38.08 23.41-53.46 60.68-.32.05-.66.08-.99.12 15.37-42.73 39.72-70.35 57.11-70.18 3.54.04 9.18 1.25 14.89 8.57 3.88 8.36 3.21 14.83 2.16 18.83Z"
          className="cls-3har2"
        />
        <path
          d="M1213.37 370.43c-1.86 0-3.38-1.5-3.41-3.36-.51-38.33 2.23-76.82 8.17-114.41 6.51-41.21 16.87-81.54 30.8-119.88.64-1.77 2.6-2.68 4.37-2.04 1.77.64 2.68 2.6 2.04 4.37-13.78 37.93-24.04 77.84-30.48 118.62-5.88 37.2-8.6 75.31-8.09 113.25a3.4 3.4 0 0 1-3.36 3.45h-.05Z"
          className="cls-3har1"
        />
        <path
          d="M1394.24 352.84c7.14 1.9 10.41 6.81 12.03 10.45 7.93 17.77.29 58.07-21.31 98.02-14.84-42.76-15.56-83.93-4.76-100.15 2.2-3.3 6.36-7.8 14.04-8.31Z"
          className="cls-3har3"
        />
        <path
          d="M1372.87 394.83c1.05-8.35 2.83-15.22 5.29-20.04 1.73-3.39 4.96-8.04 10.73-8.89 5.3 1.58 7.63 6.32 8.75 9.88 4.88 15.38.15 48.93-12.95 84.73.09.26.18.54.28.8 21.6-39.95 29.24-80.24 21.3-98.01-1.63-3.64-4.89-8.55-12.03-10.45-7.67.52-11.83 5.01-14.03 8.31-4.72 7.1-7.25 18.97-7.34 33.67Z"
          className="cls-3har2"
        />
        <path
          d="M1379.96 294.8c5.35 4.46 6.87 9.77 7.35 13.39 2.34 17.64-13.11 47.16-39.79 70.69-2.2-40.71 6.68-74.35 19.16-83.08 2.54-1.78 6.94-3.72 13.28-1Z"
          className="cls-3har3"
        />
        <path
          d="M1347.21 374.72c.45-33.64 8.59-60.18 19.47-67.79 2.54-1.78 6.94-3.72 13.29-1 4.45 3.72 6.25 8.02 7 11.45.5-3.31.58-6.4.21-9.2-.48-3.62-2-8.93-7.35-13.39-6.33-2.72-10.74-.78-13.28 1-12.05 8.44-20.75 40.1-19.33 78.93Z"
          className="cls-3har2"
        />
        <path
          d="M1374.91 220.28c5.36 4.42 6.9 9.72 7.4 13.33 2.41 17.62-12.92 47.25-39.5 70.97-2.36-40.69 6.39-74.4 18.83-83.22 2.53-1.8 6.93-3.77 13.28-1.09Z"
          className="cls-3har3"
        />
        <path
          d="M1342.81 304.59c.36-.32.71-.64 1.06-.95.11-34.3 8.21-61.51 19.21-69.31 2.53-1.8 6.92-3.77 13.28-1.09 3.09 2.54 4.91 5.39 5.99 8.02.29-2.74.29-5.3-.03-7.65-.5-3.61-2.04-8.91-7.4-13.34-6.35-2.67-10.74-.7-13.27 1.09-12.44 8.82-21.19 42.53-18.83 83.23Z"
          className="cls-3har2"
        />
        <path
          d="M1362 158.96c5.22 4.71 6.6 10.09 6.99 13.72 1.87 17.74-14.35 46.51-41.64 68.77-1.12-40.78 8.65-73.99 21.35-82.12 2.59-1.66 7.04-3.39 13.3-.37Z"
          className="cls-3har3"
        />
        <path
          d="M1327.35 241.46c.13-.11.27-.22.4-.33 4.53-40.01 18.56-69.97 32.07-74.87 1.77-.64 4.29-1.12 7.4-.22-1.05-2.33-2.68-4.78-5.22-7.07-6.26-3.02-10.71-1.29-13.3.37-12.7 8.13-22.47 41.34-21.35 82.12Z"
          className="cls-3har2"
        />
        <path
          d="M1409.85 312.85c-5.17 4.81-6.48 10.22-6.82 13.87-1.66 17.77 14.89 46.21 42.43 67.9.64-40.8-9.51-73.8-22.31-81.67-2.61-1.6-7.07-3.24-13.3-.09Z"
          className="cls-3har3"
        />
        <path
          d="M1402.98 327.2c1.02-2.07 2.52-4.21 4.71-6.25 6.22-3.14 10.7-1.5 13.3.1 11.74 7.22 21.26 35.61 22.25 71.78.73.59 1.48 1.19 2.22 1.78.64-40.8-9.52-73.8-22.31-81.67-2.6-1.6-7.07-3.24-13.3-.1-5.17 4.82-6.48 10.23-6.83 13.87-.02.16-.03.33-.04.49Z"
          className="cls-3har2"
        />
        <path
          d="M1401.57 252.29c-3.77 6.74-3.74 12.42-3.21 16.03 2.61 17.57 25.04 37.61 56.3 46.64-9.02-39-26.44-66.06-40.44-68.16-2.85-.43-7.48-.11-12.65 5.49Z"
          className="cls-3har3"
        />
        <path
          d="M1398.36 268.32c.28 1.84.77 3.72 1.47 5.59.28-2.99 1.19-6.52 3.36-10.41 5.17-5.61 9.79-5.93 12.64-5.5 12.56 1.89 27.88 23.87 37.41 56.54.47.15.94.29 1.41.42-9.02-39-26.44-66.07-40.44-68.16-2.85-.42-7.48-.11-12.65 5.49-3.77 6.74-3.74 12.43-3.21 16.03Z"
          className="cls-3har2"
        />
        <path
          d="M1389.95 182.21c-3.14 7.29-2.6 12.93-1.75 16.42 4.17 17.03 28.23 33.35 60.07 37.33-12.45-37.28-32.17-61.37-46.26-61.22-2.87.03-7.43 1.09-12.06 7.47Z"
          className="cls-3har3"
        />
        <path
          d="M1388.2 198.64c.37 1.51.9 3.03 1.57 4.52-.26-3.32.13-7.63 2.33-12.77 4.63-6.39 9.2-7.44 12.06-7.47 13.02-.14 30.85 20.42 43.3 52.94.26.04.53.07.8.11-12.45-37.28-32.17-61.38-46.26-61.23-2.86.03-7.44 1.09-12.06 7.47-3.14 7.29-2.6 12.94-1.75 16.43Z"
          className="cls-3har2"
        />
        <path
          d="M1395.33 340.5h-.04a2.868 2.868 0 0 1-2.83-2.9c.41-33.12-1.79-66.38-6.55-98.86-5.22-35.59-13.53-70.43-24.7-103.54-.51-1.5.3-3.12 1.8-3.63 1.5-.51 3.12.3 3.63 1.8 11.28 33.43 19.67 68.61 24.94 104.54 4.81 32.77 7.03 66.34 6.61 99.76a2.866 2.866 0 0 1-2.86 2.83Z"
          className="cls-3har1"
        />
        <path
          d="M1536.33 328.63c-6.35 1.7-9.26 6.11-10.71 9.38-7.06 15.94-.26 52.09 18.96 87.93 13.21-38.36 13.85-75.3 4.24-89.85-1.96-2.96-5.66-6.99-12.49-7.46Z"
          className="cls-3har3"
        />
        <path
          d="M1555.35 366.3c-.93-7.49-2.52-13.66-4.71-17.98-1.54-3.04-4.42-7.22-9.55-7.98-4.72 1.42-6.79 5.67-7.79 8.86-4.34 13.8-.13 43.89 11.53 76.01-.08.24-.16.48-.25.72-19.22-35.84-26.02-71.99-18.96-87.93 1.45-3.27 4.35-7.67 10.71-9.37 6.83.47 10.53 4.49 12.49 7.45 4.2 6.37 6.45 17.02 6.53 30.21Z"
          className="cls-3har2"
        />
        <path
          d="M1549.04 276.56c-4.76 4-6.11 8.76-6.54 12.01-2.08 15.82 11.67 42.31 35.41 63.42 1.96-36.52-5.95-66.7-17.05-74.53-2.26-1.59-6.18-3.33-11.82-.89Z"
          className="cls-3har3"
        />
        <path
          d="M1578.19 348.26c-.4-30.18-7.65-53.99-17.33-60.82-2.26-1.6-6.18-3.33-11.83-.89-3.96 3.33-5.57 7.2-6.23 10.28-.44-2.97-.52-5.75-.18-8.25.43-3.25 1.78-8.02 6.54-12.01 5.64-2.44 9.56-.7 11.82.89 10.72 7.57 18.47 35.97 17.21 70.81Z"
          className="cls-3har2"
        />
        <path
          d="M1553.53 209.71c-4.77 3.96-6.15 8.72-6.59 11.96-2.15 15.81 11.5 42.39 35.16 63.67 2.1-36.5-5.68-66.75-16.76-74.65-2.25-1.61-6.16-3.38-11.82-.98Z"
          className="cls-3har3"
        />
        <path
          d="M1582.11 285.35c-.32-.29-.63-.57-.94-.86-.1-30.77-7.31-55.19-17.1-62.18-2.25-1.61-6.16-3.38-11.82-.98-2.75 2.28-4.37 4.83-5.33 7.2-.26-2.46-.26-4.76.03-6.87.45-3.24 1.82-8 6.59-11.97 5.65-2.39 9.56-.63 11.81.98 11.08 7.91 18.86 38.16 16.76 74.66Z"
          className="cls-3har2"
        />
        <path
          d="M1565.02 154.69c-4.65 4.22-5.88 9.05-6.22 12.31-1.67 15.91 12.77 41.72 37.06 61.69.99-36.59-7.7-66.38-19-73.68-2.3-1.49-6.26-3.04-11.84-.33Z"
          className="cls-3har3"
        />
        <path
          d="M1595.87 228.71c-.12-.1-.24-.2-.36-.29-4.03-35.9-16.52-62.77-28.55-67.17-1.58-.57-3.82-1.01-6.58-.2.93-2.09 2.39-4.29 4.65-6.34 5.57-2.71 9.54-1.16 11.84.33 11.3 7.29 20 37.09 19 73.68Z"
          className="cls-3har2"
        />
        <path
          d="M1522.44 292.76c4.6 4.32 5.77 9.17 6.07 12.44 1.48 15.94-13.26 41.45-37.77 60.91-.57-36.61 8.47-66.21 19.85-73.27 2.32-1.44 6.3-2.91 11.84-.08Z"
          className="cls-3har3"
        />
        <path
          d="M1528.55 305.63c-.91-1.86-2.25-3.78-4.19-5.6-5.54-2.82-9.52-1.35-11.84.09-10.45 6.48-18.92 31.95-19.8 64.4-.65.53-1.31 1.06-1.98 1.6-.57-36.6 8.47-66.21 19.86-73.27 2.32-1.43 6.29-2.91 11.84-.09 4.6 4.32 5.77 9.17 6.08 12.44.01.14.03.29.04.44Z"
          className="cls-3har2"
        />
        <path
          d="M1529.81 238.42c3.36 6.04 3.33 11.15 2.85 14.38-2.33 15.76-22.29 33.74-50.11 41.84 8.03-34.99 23.54-59.26 36-61.15 2.54-.38 6.66-.1 11.26 4.93Z"
          className="cls-3har3"
        />
        <path
          d="M1532.66 252.8a25.57 25.57 0 0 1-1.31 5.01c-.25-2.68-1.06-5.85-2.99-9.34-4.6-5.03-8.72-5.32-11.25-4.94-11.18 1.7-24.82 21.42-33.3 50.72-.42.13-.83.26-1.26.38 8.03-34.99 23.54-59.27 36-61.15 2.54-.38 6.65-.1 11.26 4.93 3.36 6.05 3.33 11.15 2.85 14.38Z"
          className="cls-3har2"
        />
        <path
          d="M1540.15 175.55c2.79 6.54 2.32 11.6 1.55 14.73-3.71 15.27-25.12 29.91-53.47 33.49 11.08-33.45 28.64-55.06 41.18-54.92 2.55.03 6.62.97 10.74 6.7Z"
          className="cls-3har3"
        />
        <path
          d="M1541.71 190.29c-.33 1.36-.8 2.72-1.4 4.06.23-2.98-.11-6.85-2.08-11.45-4.13-5.74-8.19-6.68-10.74-6.71-11.58-.12-27.46 18.32-38.54 47.49-.23.04-.47.07-.71.1 11.08-33.45 28.64-55.06 41.18-54.93 2.55.03 6.62.98 10.74 6.7 2.8 6.54 2.32 11.61 1.55 14.74Z"
          className="cls-3har2"
        />
        <path
          d="M1535.36 317.55c-1.4 0-2.54-1.12-2.56-2.53-.37-29.98 1.61-60.09 5.89-89.49 4.69-32.23 12.16-63.79 22.2-93.78a2.557 2.557 0 1 1 4.85 1.63c-9.94 29.7-17.34 60.96-21.98 92.89-4.24 29.14-6.2 58.98-5.83 88.69a2.559 2.559 0 0 1-2.53 2.59h-.03ZM858.65 1877.71c10.69 3.07 43.03-90.09 39.12-180.94-1.54-35.63-8.29-62.63-13.89-79.94-.51 12.99-1.76 33.93-5.43 59.14-8.5 58.45-20.83 77.25-24.9 124.5-2.66 30.86-1.92 75.22 5.1 77.24ZM989.2 1871.7c10.69 3.07 43.03-90.09 39.12-180.94-1.54-35.63-8.29-62.63-13.89-79.94-.51 12.99-1.76 33.93-5.43 59.14-8.5 58.45-20.83 77.25-24.9 124.5-2.66 30.86-1.92 75.22 5.1 77.24ZM1056.44 1870.35c7.25 10.09 52.29-9.17 69.89-56.46 6.9-18.55 7.98-37.1 7.73-50.01-3.31 5.9-8.97 15.07-17.38 24.37-19.5 21.57-32.9 20.79-46.59 40.47-8.94 12.86-18.4 35.01-13.64 41.64Z"
          className="cls-3har1"
        />
        <path
          d="M986.41 1870.39c-9.04 9.14-48.32-9.75-55.44-53.85-2.79-17.3 0-34.45 2.92-46.37 1.96 5.53 5.5 14.13 11.65 22.93 14.27 20.39 27.3 20 36.37 38.51 5.93 12.09 10.43 32.78 4.5 38.78ZM1373.22 1869.16c7.04 10.87 52.15-3.38 70.45-48.63 7.18-17.75 8.56-36.14 8.53-49.05-3.39 5.53-9.17 14.04-17.7 22.4-19.76 19.37-33.07 17.11-47.01 35.24-9.11 11.84-18.89 32.9-14.27 40.04ZM1258.54 1883.48c-13.58 12.49-83.07-47.04-103.01-136.83-7.82-35.22-6.2-66.91-3.45-88.36 4.29 11.88 11.8 30.64 23.75 51.31 27.69 47.91 49.55 54.72 68.16 95.95 12.16 26.93 23.47 69.73 14.55 77.93Z"
          className="cls-3har1"
        />
        <path
          d="M1259.9 1883.06c21.45 9 87.16-78.07 80.04-181.46-2.79-40.55-16.14-74.19-27.24-96.41-1.12 14.22-3.82 36.92-11.39 63.14-17.55 60.77-42.46 75.32-51.03 125.9-5.6 33.04-4.46 82.91 9.62 88.82ZM1567.36 1877.61c-10.97 8.59-66-54.06-81.11-134.83-5.93-31.68-4.33-58.78-1.94-76.86 3.32 10.96 9.15 28.37 18.51 48.15 21.7 45.85 39.12 55.28 53.62 93.89 9.47 25.22 18.12 64.01 10.92 69.65Z"
          className="cls-3har1"
        />
        <path
          d="M1566.47 1873.79c13.04 5.5 54.78-56.69 52.01-127.72-1.09-27.86-8.76-50.61-15.24-65.56-.91 9.84-2.92 25.58-7.98 43.9-11.73 42.47-27.27 53.32-33.32 88.47-3.95 22.96-4.03 57.3 4.53 60.91ZM687.06 1874.64c10.41 4.83 51.95-81.59 56.93-171.83 1.95-35.39-2.17-63.15-6.08-81.16a537.19 537.19 0 0 1-11.24 57.4c-14.24 56.2-28.44 72.67-37.15 118.57-5.69 29.98-9.29 73.85-2.46 77.02ZM522.02 1870.69c-8.95 12.48-80.77-34.68-116.69-113.6-14.09-30.95-19.38-59.6-21.56-79.14 6.16 10.29 16.52 26.47 31.06 43.96 33.71 40.54 53.79 44.67 78.35 80.04 16.04 23.1 34.71 60.55 28.83 68.74Z"
          className="cls-3har1"
        />
        <path
          d="M515.15 1871.81c12.38 5.96 57.77-67.57 60.21-149.94.95-32.31-4.92-58.47-10.18-75.62-1.61 11.46-4.72 29.79-11 51.22-14.57 49.68-30.57 62.78-39.05 103.78-5.53 26.78-8.1 66.65.03 70.57ZM683.1 1872.19c-10.35 2.47-37.69-59.87-30.42-121.92 2.85-24.34 10.37-42.97 16.39-54.96-.02 8.83.37 23.06 2.9 40.11 5.87 39.53 16.94 51.91 19 83.96 1.35 20.94-1.08 51.19-7.88 52.82ZM854.12 1881.95c-9.01 6.96-51.81-39.11-62.15-100.45-4.05-24.06-2.17-44.87.16-58.8 2.42 8.28 6.72 21.41 13.8 36.24 16.41 34.37 30.19 40.98 40.98 70.05 7.04 18.99 13.13 48.4 7.21 52.97ZM625.16 1880.13c-10.35 2.47-37.69-59.87-30.42-121.92 2.85-24.34 10.37-42.97 16.39-54.96-.02 8.83.37 23.06 2.9 40.11 5.87 39.53 16.94 51.91 19 83.96 1.35 20.94-1.08 51.19-7.88 52.82Z"
          className="cls-3har1"
        />
        <path
          d="M483.26 1644.15c-8.99-2.02-13.11-7.26-15.16-11.15-9.99-18.96-.37-61.95 26.84-104.57 18.7 45.62 19.61 89.54 6 106.85-2.77 3.52-8.01 8.32-17.68 8.87Z"
          className="cls-3har3"
        />
        <path
          d="M510.19 1599.36c-1.32 8.91-3.57 16.24-6.67 21.38-2.18 3.61-6.25 8.58-13.52 9.49-6.68-1.68-9.61-6.74-11.03-10.54-6.15-16.41-.19-52.2 16.32-90.39-.12-.28-.23-.58-.35-.86-27.21 42.62-36.84 85.61-26.84 104.57 2.05 3.88 6.16 9.12 15.16 11.15 9.67-.55 14.91-5.34 17.68-8.86 5.95-7.58 9.13-20.24 9.25-35.92Z"
          className="cls-3har2"
        />
        <path
          d="M501.26 1706.07c-6.74-4.75-8.65-10.42-9.26-14.28-2.95-18.82 16.52-50.31 50.13-75.42 2.77 43.43-8.42 79.33-24.14 88.63-3.2 1.9-8.75 3.97-16.73 1.06Z"
          className="cls-3har3"
        />
        <path
          d="M542.52 1620.81c-.57 35.89-10.83 64.2-24.53 72.32-3.2 1.9-8.75 3.96-16.74 1.06-5.61-3.96-7.88-8.56-8.82-12.22-.63 3.53-.73 6.83-.26 9.81.61 3.86 2.52 9.53 9.26 14.29 7.98 2.9 13.53.84 16.73-1.06 15.18-9 26.14-42.78 24.36-84.2Z"
          className="cls-3har2"
        />
        <path
          d="M507.62 1785.57c-6.76-4.71-8.7-10.37-9.32-14.23-3.04-18.8 16.28-50.41 49.77-75.72 2.97 43.41-8.05 79.37-23.72 88.78-3.19 1.92-8.73 4.02-16.73 1.16Z"
          className="cls-3har3"
        />
        <path
          d="M548.07 1695.63c-.45.34-.89.68-1.33 1.02-.14 36.59-10.35 65.63-24.21 73.94-3.19 1.92-8.72 4.02-16.73 1.16-3.89-2.71-6.19-5.75-7.55-8.56-.37 2.92-.37 5.66.04 8.17.63 3.85 2.57 9.51 9.33 14.23 8 2.85 13.53.74 16.72-1.16 15.68-9.41 26.7-45.38 23.73-88.79Z"
          className="cls-3har2"
        />
        <path
          d="M523.88 1850.99c-6.58-5.02-8.32-10.76-8.8-14.64-2.36-18.92 18.08-49.62 52.46-73.37 1.41 43.51-10.9 78.94-26.9 87.61-3.26 1.77-8.86 3.61-16.76.39Z"
          className="cls-3har3"
        />
        <path
          d="M567.54 1762.98c-.17.11-.34.24-.51.35-5.71 42.69-23.38 74.65-40.41 79.88-2.23.68-5.41 1.2-9.32.24 1.32 2.48 3.38 5.1 6.58 7.54 7.89 3.22 13.5 1.38 16.76-.4 16-8.67 28.31-44.1 26.9-87.62Z"
          className="cls-3har2"
        />
        <path
          d="M463.6 1686.81c6.51-5.13 8.17-10.91 8.6-14.79 2.1-18.96-18.76-49.29-53.47-72.44-.81 43.53 11.99 78.74 28.11 87.13 3.28 1.71 8.91 3.46 16.76.1Z"
          className="cls-3har3"
        />
        <path
          d="M472.25 1671.5c-1.29 2.21-3.18 4.49-5.93 6.66-7.84 3.35-13.48 1.6-16.76-.1-14.79-7.7-26.79-37.99-28.03-76.58-.92-.63-1.86-1.27-2.8-1.9-.8 43.53 11.99 78.74 28.11 87.13 3.28 1.71 8.91 3.46 16.76.1 6.51-5.14 8.17-10.91 8.6-14.79.02-.17.04-.35.05-.52Z"
          className="cls-3har2"
        />
        <path
          d="M474.03 1751.43c4.75-7.19 4.72-13.25 4.04-17.1-3.29-18.74-31.55-40.12-70.93-49.75 11.36 41.61 33.32 70.48 50.96 72.72 3.59.46 9.42.11 15.94-5.86Z"
          className="cls-3har3"
        />
        <path
          d="M478.07 1734.33c-.35-1.96-.97-3.96-1.85-5.96-.35 3.18-1.5 6.96-4.24 11.1-6.51 5.99-12.34 6.32-15.93 5.87-15.83-2.02-35.13-25.47-47.14-60.32-.59-.16-1.18-.3-1.78-.45 11.37 41.61 33.32 70.48 50.96 72.72 3.59.45 9.42.11 15.94-5.86 4.75-7.19 4.71-13.26 4.04-17.1Z"
          className="cls-3har2"
        />
        <path
          d="M488.67 1826.19c3.96-7.78 3.28-13.8 2.2-17.52-5.25-18.16-35.57-35.57-75.69-39.82 15.69 39.77 40.54 65.47 58.29 65.32 3.61-.03 9.37-1.16 15.2-7.97Z"
          className="cls-3har3"
        />
        <path
          d="M490.87 1808.66c-.47-1.62-1.13-3.23-1.98-4.82.33 3.55-.16 8.14-2.94 13.62-5.84 6.82-11.59 7.94-15.2 7.97-16.4.15-38.87-21.79-54.56-56.48-.33-.05-.67-.08-1.01-.11 15.69 39.78 40.54 65.48 58.29 65.32 3.61-.03 9.37-1.16 15.2-7.97 3.96-7.78 3.28-13.8 2.2-17.53Z"
          className="cls-3har2"
        />
        <path
          d="M521.46 1880.64c-1.32 0-2.57-.79-3.09-2.09-14.23-35.71-24.81-73.27-31.46-111.66-6.06-35.01-8.87-70.86-8.34-106.56.03-1.83 1.54-3.28 3.37-3.27 1.83.03 3.3 1.54 3.27 3.37-.52 35.29 2.26 70.73 8.25 105.33 6.57 37.93 17.03 75.05 31.08 110.33.68 1.7-.15 3.63-1.86 4.31-.4.16-.82.24-1.23.24Z"
          className="cls-3har1"
        />
        <path
          d="M659.04 1594c10.09-2.36 14.72-8.48 17.02-13.02 11.21-22.14.41-72.36-30.13-122.15-20.99 53.28-22.01 104.59-6.74 124.81 3.11 4.12 8.99 9.72 19.85 10.36Z"
          className="cls-3har3"
        />
        <path
          d="M628.81 1541.67c1.48 10.41 4.01 18.97 7.49 24.97 2.45 4.22 7.01 10.03 15.17 11.08 7.5-1.97 10.79-7.88 12.38-12.31 6.9-19.17.21-60.97-18.32-105.59.13-.33.26-.67.39-1 30.54 49.79 41.35 99.99 30.13 122.14-2.3 4.54-6.91 10.66-17.02 13.02-10.85-.65-16.74-6.24-19.84-10.35-6.68-8.85-10.25-23.64-10.38-41.96Z"
          className="cls-3har2"
        />
        <path
          d="M638.85 1666.32c7.56-5.55 9.71-12.17 10.39-16.68 3.31-21.98-18.54-58.76-56.27-88.09-3.11 50.73 9.45 92.66 27.1 103.53 3.59 2.21 9.82 4.63 18.78 1.24Z"
          className="cls-3har3"
        />
        <path
          d="M592.53 1566.72c.64 41.92 12.16 74.99 27.53 84.48 3.59 2.22 9.82 4.63 18.79 1.24 6.3-4.63 8.84-10 9.9-14.27.71 4.13.82 7.98.29 11.46-.68 4.51-2.83 11.13-10.39 16.69-8.96 3.39-15.19.98-18.78-1.24-17.04-10.51-29.34-49.97-27.34-98.36Z"
          className="cls-3har2"
        />
        <path
          d="M631.7 1759.19c7.59-5.5 9.76-12.11 10.46-16.62 3.41-21.96-18.27-58.88-55.87-88.44-3.34 50.71 9.03 92.72 26.63 103.7 3.58 2.24 9.79 4.69 18.78 1.36Z"
          className="cls-3har3"
        />
        <path
          d="M586.3 1654.12c.51.4 1 .79 1.49 1.19.16 42.74 11.62 76.66 27.17 86.37 3.58 2.24 9.79 4.7 18.78 1.36 4.37-3.17 6.95-6.71 8.47-10 .41 3.42.41 6.61-.04 9.54-.71 4.5-2.88 11.11-10.47 16.62-8.98 3.32-15.19.87-18.77-1.36-17.6-10.99-29.97-53-26.63-103.71Z"
          className="cls-3har2"
        />
        <path
          d="M613.45 1835.6c7.39-5.86 9.34-12.57 9.88-17.1 2.65-22.1-20.3-57.96-58.88-85.7-1.58 50.82 12.24 92.21 30.2 102.34 3.66 2.06 9.95 4.22 18.81.46Z"
          className="cls-3har3"
        />
        <path
          d="M564.45 1732.79c.19.13.38.28.57.41 6.41 49.86 26.24 87.2 45.36 93.3 2.5.79 6.07 1.4 10.46.28-1.48 2.9-3.79 5.96-7.39 8.81-8.86 3.76-15.15 1.61-18.81-.46-17.96-10.13-31.78-51.51-30.19-102.34Z"
          className="cls-3har2"
        />
        <path
          d="M681.11 1643.83c-7.31-6-9.17-12.74-9.65-17.28-2.35-22.15 21.06-57.58 60.01-84.61.91 50.85-13.45 91.97-31.55 101.78-3.68 2-10 4.04-18.81.12Z"
          className="cls-3har3"
        />
        <path
          d="M671.4 1625.94c1.45 2.59 3.57 5.25 6.66 7.78 8.8 3.92 15.13 1.87 18.81-.12 16.6-9 30.07-44.38 31.46-89.45 1.03-.74 2.09-1.48 3.14-2.22.9 50.84-13.46 91.97-31.55 101.77-3.68 1.99-10 4.04-18.81.12-7.31-6-9.17-12.74-9.65-17.28l-.06-.61Z"
          className="cls-3har2"
        />
        <path
          d="M669.4 1719.3c-5.33-8.4-5.29-15.48-4.53-19.97 3.7-21.89 35.41-46.86 79.62-58.12-12.76 48.6-37.4 82.32-57.19 84.94-4.03.53-10.58.13-17.89-6.85Z"
          className="cls-3har3"
        />
        <path
          d="M664.87 1699.33c.39-2.3 1.09-4.63 2.08-6.96.39 3.72 1.68 8.13 4.76 12.97 7.31 6.99 13.85 7.39 17.88 6.86 17.77-2.36 39.43-29.75 52.91-70.46.66-.18 1.32-.36 2-.53-12.76 48.6-37.4 82.33-57.2 84.94-4.03.53-10.57.13-17.89-6.85-5.33-8.4-5.29-15.49-4.53-19.97Z"
          className="cls-3har2"
        />
        <path
          d="M652.97 1806.63c-4.44-9.09-3.68-16.12-2.47-20.47 5.9-21.22 39.92-41.55 84.96-46.52-17.61 46.46-45.5 76.48-65.42 76.29-4.06-.04-10.51-1.35-17.06-9.31Z"
          className="cls-3har3"
        />
        <path
          d="M650.5 1786.15c.53-1.89 1.27-3.77 2.22-5.63-.37 4.14.18 9.51 3.3 15.91 6.55 7.97 13.01 9.27 17.06 9.31 18.41.17 43.63-25.45 61.24-65.97.37-.05.75-.09 1.13-.13-17.61 46.46-45.5 76.49-65.42 76.3-4.05-.04-10.52-1.36-17.06-9.31-4.44-9.09-3.68-16.12-2.47-20.47Z"
          className="cls-3har2"
        />
        <path
          d="M616.17 1870.15a3.803 3.803 0 0 1-3.55-5.16c15.78-41.22 27.52-84.6 34.9-128.91 6.73-40.43 9.84-81.84 9.26-123.08a3.807 3.807 0 0 1 3.75-3.86 3.814 3.814 0 0 1 3.86 3.75c.59 41.69-2.56 83.55-9.36 124.43-7.46 44.82-19.33 88.69-35.3 130.38a3.804 3.804 0 0 1-3.55 2.44Z"
          className="cls-3har1"
        />
        <path
          d="M824.31 1628.67c-7.88-2.03-11.48-7.3-13.28-11.2-8.75-19.05-.32-62.24 23.51-105.06 16.38 45.83 17.17 89.96 5.26 107.35-2.43 3.54-7.01 8.36-15.49 8.91Z"
          className="cls-3har3"
        />
        <path
          d="M847.89 1583.67c-1.16 8.95-3.13 16.32-5.84 21.48-1.91 3.63-5.47 8.62-11.84 9.53-5.85-1.69-8.42-6.77-9.66-10.59-5.39-16.49-.17-52.44 14.29-90.82-.1-.28-.2-.58-.31-.86-23.83 42.82-32.26 86.01-23.51 105.06 1.8 3.9 5.39 9.17 13.28 11.2 8.47-.56 13.06-5.37 15.48-8.91 5.21-7.61 8-20.33 8.1-36.09Z"
          className="cls-3har2"
        />
        <path
          d="M840.07 1690.88c-5.9-4.78-7.58-10.47-8.11-14.35-2.58-18.9 14.47-50.54 43.9-75.77 2.42 43.63-7.38 79.7-21.14 89.05-2.8 1.9-7.66 3.98-14.65 1.07Z"
          className="cls-3har3"
        />
        <path
          d="M876.21 1605.21c-.5 36.06-9.48 64.5-21.48 72.66-2.8 1.91-7.66 3.98-14.66 1.07-4.91-3.98-6.9-8.6-7.72-12.28-.55 3.55-.64 6.86-.23 9.86.53 3.88 2.21 9.58 8.11 14.35 6.99 2.92 11.85.84 14.65-1.07 13.29-9.04 22.89-42.98 21.33-84.6Z"
          className="cls-3har2"
        />
        <path
          d="M845.64 1770.75c-5.92-4.73-7.62-10.42-8.16-14.29-2.66-18.89 14.26-50.64 43.59-76.07 2.6 43.61-7.05 79.75-20.77 89.2-2.8 1.92-7.64 4.04-14.65 1.17Z"
          className="cls-3har3"
        />
        <path
          d="M881.07 1680.38c-.39.34-.78.68-1.16 1.02-.12 36.76-9.06 65.93-21.2 74.29-2.79 1.93-7.64 4.04-14.65 1.17-3.41-2.72-5.42-5.78-6.61-8.6-.32 2.94-.32 5.68.04 8.2.55 3.87 2.25 9.55 8.17 14.3 7.01 2.86 11.85.75 14.64-1.17 13.73-9.45 23.38-45.59 20.78-89.21Z"
          className="cls-3har2"
        />
        <path
          d="M859.88 1836.48c-5.76-5.04-7.29-10.81-7.71-14.71-2.06-19.01 15.84-49.85 45.94-73.71 1.23 43.72-9.55 79.31-23.56 88.03-2.85 1.78-7.76 3.63-14.67.4Z"
          className="cls-3har3"
        />
        <path
          d="M898.12 1748.05c-.15.11-.3.24-.45.35-5 42.89-20.48 75-35.39 80.25-1.95.68-4.74 1.2-8.16.24 1.16 2.5 2.96 5.13 5.76 7.58 6.91 3.23 11.82 1.38 14.68-.4 14.01-8.71 24.79-44.31 23.56-88.03Z"
          className="cls-3har2"
        />
        <path
          d="M807.09 1671.53c5.7-5.16 7.15-10.96 7.53-14.86 1.84-19.05-16.43-49.53-46.82-72.78-.71 43.74 10.5 79.11 24.61 87.54 2.87 1.72 7.81 3.47 14.68.1Z"
          className="cls-3har3"
        />
        <path
          d="M814.67 1656.15c-1.13 2.22-2.78 4.52-5.19 6.69-6.87 3.37-11.81 1.61-14.68-.1-12.95-7.74-23.46-38.17-24.55-76.94-.81-.64-1.63-1.27-2.45-1.91-.7 43.73 10.5 79.11 24.62 87.54 2.87 1.71 7.8 3.47 14.68.1 5.7-5.16 7.15-10.96 7.53-14.86.02-.17.04-.35.04-.52Z"
          className="cls-3har2"
        />
        <path
          d="M816.22 1736.44c4.16-7.22 4.13-13.32 3.54-17.18-2.88-18.83-27.63-40.31-62.12-49.99 9.95 41.8 29.18 70.81 44.63 73.06 3.15.46 8.25.11 13.96-5.89Z"
          className="cls-3har3"
        />
        <path
          d="M819.77 1719.27a29.67 29.67 0 0 0-1.62-5.99c-.31 3.2-1.31 6.99-3.71 11.15-5.7 6.01-10.81 6.35-13.95 5.9-13.86-2.03-30.77-25.59-41.28-60.6-.52-.16-1.03-.31-1.56-.45 9.96 41.8 29.18 70.81 44.63 73.06 3.14.45 8.25.11 13.96-5.89 4.16-7.23 4.12-13.32 3.54-17.18Z"
          className="cls-3har2"
        />
        <path
          d="M829.05 1811.56c3.46-7.81 2.87-13.86 1.93-17.6-4.6-18.25-31.15-35.74-66.29-40.01 13.74 39.96 35.5 65.78 51.05 65.62 3.17-.03 8.2-1.16 13.31-8.01Z"
          className="cls-3har3"
        />
        <path
          d="M830.97 1793.95c-.41-1.62-.99-3.25-1.73-4.84.29 3.56-.14 8.18-2.57 13.68-5.11 6.85-10.15 7.98-13.31 8.01-14.36.15-34.04-21.89-47.78-56.74-.29-.05-.59-.08-.88-.11 13.74 39.96 35.5 65.79 51.05 65.63 3.16-.03 8.21-1.17 13.31-8.01 3.47-7.82 2.87-13.87 1.93-17.61Z"
          className="cls-3har2"
        />
        <path
          d="M857.76 1866.04c-1.29 0-2.5-.81-2.94-2.09-12.45-35.84-21.71-73.55-27.52-112.07-5.3-35.14-7.76-71.12-7.3-106.95.02-1.72 1.43-3.12 3.15-3.07a3.1 3.1 0 0 1 3.07 3.15c-.46 35.49 1.98 71.14 7.23 105.94 5.76 38.14 14.93 75.48 27.25 110.96.56 1.62-.3 3.4-1.92 3.96-.34.12-.68.17-1.02.17Z"
          className="cls-3har1"
        />
        <path
          d="M965.99 1698.37c-5.46-1.41-7.97-5.06-9.21-7.77-6.07-13.21-.22-43.18 16.31-72.88 11.36 31.79 11.91 62.41 3.65 74.47-1.68 2.46-4.87 5.8-10.74 6.18Z"
          className="cls-3har3"
        />
        <path
          d="M982.36 1667.15c-.8 6.21-2.17 11.32-4.05 14.9-1.32 2.52-3.8 5.98-8.21 6.61-4.06-1.17-5.84-4.7-6.7-7.34-3.74-11.44-.12-36.38 9.91-63l-.21-.6c-16.53 29.71-22.38 59.67-16.31 72.88 1.25 2.71 3.74 6.36 9.21 7.77 5.87-.39 9.06-3.72 10.74-6.18 3.61-5.28 5.55-14.11 5.62-25.04Z"
          className="cls-3har2"
        />
        <path
          d="M976.93 1741.52c-4.09-3.31-5.26-7.26-5.62-9.95-1.79-13.11 10.04-35.06 30.46-52.56 1.68 30.27-5.12 55.29-14.67 61.78-1.94 1.32-5.31 2.76-10.17.74Z"
          className="cls-3har3"
        />
        <path
          d="M1002 1682.09c-.35 25.02-6.58 44.75-14.9 50.41-1.94 1.32-5.32 2.76-10.17.74-3.41-2.76-4.79-5.97-5.36-8.52-.38 2.46-.44 4.76-.16 6.84.37 2.69 1.53 6.64 5.63 9.96 4.85 2.02 8.22.58 10.16-.74 9.22-6.27 15.88-29.82 14.8-58.69Z"
          className="cls-3har2"
        />
        <path
          d="M980.79 1796.93c-4.11-3.28-5.29-7.23-5.66-9.91-1.85-13.1 9.89-35.13 30.24-52.77 1.81 30.26-4.89 55.32-14.41 61.88-1.94 1.33-5.3 2.8-10.16.81Z"
          className="cls-3har3"
        />
        <path
          d="M1005.37 1734.24c-.27.24-.54.47-.81.71-.09 25.5-6.29 45.74-14.71 51.53-1.94 1.34-5.3 2.8-10.16.81-2.36-1.89-3.76-4.01-4.59-5.97-.22 2.04-.22 3.94.02 5.69.38 2.68 1.56 6.63 5.67 9.92 4.86 1.98 8.22.52 10.16-.81 9.53-6.56 16.22-31.63 14.42-61.88Z"
          className="cls-3har2"
        />
        <path
          d="M990.67 1842.53c-4-3.5-5.05-7.5-5.35-10.21-1.43-13.19 10.99-34.58 31.87-51.14.85 30.33-6.62 55.02-16.34 61.07-1.98 1.23-5.39 2.52-10.18.27Z"
          className="cls-3har3"
        />
        <path
          d="M1017.2 1781.19c-.1.08-.21.17-.31.24-3.47 29.75-14.2 52.03-24.55 55.67-1.35.47-3.29.83-5.66.17.8 1.73 2.05 3.56 4 5.26 4.79 2.24 8.2.96 10.18-.28 9.72-6.05 17.2-30.74 16.34-61.07Z"
          className="cls-3har2"
        />
        <path
          d="M954.05 1728.1c3.96-3.58 4.96-7.6 5.22-10.31 1.27-13.22-11.4-34.36-32.48-50.49-.49 30.34 7.28 54.88 17.08 60.73 1.99 1.19 5.41 2.41 10.18.07Z"
          className="cls-3har3"
        />
        <path
          d="M959.3 1717.43c-.78 1.54-1.93 3.13-3.6 4.64-4.76 2.34-8.19 1.12-10.18-.07-8.99-5.37-16.28-26.48-17.03-53.38-.56-.44-1.13-.88-1.7-1.32-.49 30.34 7.28 54.88 17.08 60.73 1.99 1.19 5.41 2.41 10.18.07 3.96-3.58 4.96-7.6 5.22-10.31l.03-.36Z"
          className="cls-3har2"
        />
        <path
          d="M960.38 1773.13c2.89-5.01 2.86-9.24 2.45-11.92-2-13.06-19.17-27.96-43.1-34.68 6.9 29 20.24 49.12 30.96 50.68 2.18.32 5.73.08 9.68-4.09Z"
          className="cls-3har3"
        />
        <path
          d="M962.84 1761.22c-.21-1.37-.59-2.76-1.12-4.16-.21 2.22-.91 4.85-2.58 7.74-3.96 4.17-7.5 4.41-9.68 4.09-9.62-1.41-21.34-17.75-28.64-42.04-.36-.11-.72-.21-1.08-.32 6.91 29 20.24 49.13 30.96 50.68 2.18.31 5.72.08 9.68-4.09 2.89-5.01 2.86-9.24 2.45-11.92Z"
          className="cls-3har2"
        />
        <path
          d="M969.28 1825.24c2.4-5.42 1.99-9.62 1.34-12.21-3.19-12.66-21.61-24.79-45.99-27.76 9.53 27.72 24.63 45.63 35.41 45.52 2.2-.02 5.69-.81 9.24-5.56Z"
          className="cls-3har3"
        />
        <path
          d="M970.62 1813.03c-.29-1.13-.69-2.25-1.2-3.36.2 2.47-.1 5.68-1.79 9.49-3.55 4.75-7.04 5.53-9.23 5.56-9.96.1-23.61-15.18-33.15-39.37-.2-.03-.41-.05-.61-.08 9.53 27.72 24.63 45.64 35.41 45.53 2.19-.02 5.69-.81 9.23-5.56 2.41-5.42 1.99-9.62 1.34-12.22Z"
          className="cls-3har2"
        />
        <path
          d="M989.2 1863.04c-.89 0-1.73-.56-2.04-1.45-8.64-24.86-15.06-51.02-19.09-77.75-3.68-24.37-5.38-49.34-5.06-74.19.02-1.19 1.01-2.16 2.19-2.13 1.19.02 2.15.99 2.13 2.19-.32 24.62 1.37 49.35 5.02 73.49 3.99 26.46 10.35 52.36 18.9 76.97a2.157 2.157 0 0 1-2.04 2.87Z"
          className="cls-3har1"
        />
        <path
          d="M1081.84 1656.36c6.12-1.84 8.92-6.59 10.32-10.12 6.8-17.21.25-56.24-18.27-94.93-12.73 41.41-13.35 81.29-4.08 97 1.89 3.2 5.45 7.55 12.04 8.05Z"
          className="cls-3har3"
        />
        <path
          d="M1063.5 1615.7c.9 8.09 2.43 14.74 4.54 19.41 1.48 3.28 4.25 7.79 9.2 8.61 4.55-1.53 6.54-6.12 7.51-9.57 4.19-14.9.13-47.39-11.11-82.06l.24-.78c18.52 38.69 25.08 77.72 18.27 94.93-1.4 3.53-4.19 8.28-10.32 10.12-6.58-.5-10.15-4.85-12.03-8.05-4.05-6.88-6.21-18.37-6.3-32.61Z"
          className="cls-3har2"
        />
        <path
          d="M1069.59 1712.57c4.58-4.32 5.89-9.46 6.3-12.97 2.01-17.08-11.24-45.67-34.12-68.47-1.88 39.43 5.73 72.02 16.43 80.47 2.18 1.72 5.95 3.6 11.39.97Z"
          className="cls-3har3"
        />
        <path
          d="M1041.5 1635.17c.39 32.58 7.37 58.29 16.7 65.66 2.18 1.72 5.96 3.6 11.39.96 3.82-3.6 5.36-7.77 6-11.09.43 3.21.5 6.2.18 8.91-.42 3.51-1.72 8.65-6.3 12.97-5.43 2.64-9.21.76-11.39-.96-10.33-8.17-17.79-38.84-16.58-76.45Z"
          className="cls-3har2"
        />
        <path
          d="M1065.26 1784.75c4.6-4.28 5.92-9.41 6.35-12.91 2.07-17.07-11.08-45.76-33.88-68.74-2.02 39.41 5.48 72.06 16.15 80.6 2.17 1.74 5.94 3.65 11.39 1.06Z"
          className="cls-3har3"
        />
        <path
          d="M1037.72 1703.09c.31.31.61.62.91.92.1 33.22 7.04 59.58 16.48 67.12 2.17 1.74 5.94 3.65 11.39 1.06 2.65-2.46 4.21-5.22 5.14-7.77.25 2.66.25 5.14-.03 7.41-.43 3.5-1.75 8.63-6.35 12.92-5.45 2.58-9.21.68-11.38-1.06-10.67-8.54-18.17-41.2-16.15-80.61Z"
          className="cls-3har2"
        />
        <path
          d="M1054.19 1844.14c4.48-4.56 5.66-9.77 5.99-13.29 1.6-17.18-12.31-45.05-35.71-66.61-.96 39.5 7.42 71.66 18.31 79.54 2.22 1.6 6.03 3.28 11.41.36Z"
          className="cls-3har3"
        />
        <path
          d="M1024.47 1764.24c.12.1.23.22.35.32 3.89 38.76 15.91 67.77 27.51 72.52 1.52.62 3.68 1.09 6.34.22-.9 2.26-2.3 4.63-4.48 6.85-5.37 2.92-9.19 1.25-11.41-.36-10.89-7.87-19.27-40.04-18.31-79.54Z"
          className="cls-3har2"
        />
        <path
          d="M1095.22 1695.09c-4.43-4.66-5.56-9.9-5.85-13.43-1.43-17.21 12.77-44.75 36.39-65.76.55 39.52-8.16 71.48-19.13 79.1-2.23 1.55-6.07 3.14-11.41.09Z"
          className="cls-3har3"
        />
        <path
          d="M1089.33 1681.19c.88 2.01 2.16 4.08 4.04 6.05 5.34 3.05 9.18 1.46 11.41-.09 10.07-6.99 18.23-34.49 19.08-69.52.63-.57 1.27-1.15 1.91-1.72.54 39.51-8.16 71.48-19.13 79.1-2.23 1.55-6.06 3.14-11.41.09-4.43-4.66-5.56-9.9-5.85-13.43-.01-.15-.03-.32-.03-.47Z"
          className="cls-3har2"
        />
        <path
          d="M1088.12 1753.75c-3.23-6.53-3.21-12.03-2.75-15.52 2.24-17.02 21.47-36.42 48.28-45.17-7.74 37.77-22.68 63.98-34.68 66.02-2.44.41-6.41.1-10.85-5.32Z"
          className="cls-3har3"
        />
        <path
          d="M1085.37 1738.23c.24-1.78.66-3.6 1.26-5.41.24 2.89 1.02 6.32 2.89 10.08 4.43 5.43 8.4 5.74 10.84 5.33 10.77-1.84 23.91-23.12 32.09-54.76.4-.14.8-.28 1.21-.41-7.74 37.77-22.68 63.99-34.69 66.02-2.44.41-6.41.1-10.85-5.32-3.23-6.53-3.21-12.04-2.75-15.52Z"
          className="cls-3har2"
        />
        <path
          d="M1078.15 1821.62c-2.69-7.06-2.23-12.53-1.5-15.91 3.58-16.49 24.21-32.3 51.52-36.15-10.68 36.11-27.59 59.44-39.67 59.3-2.46-.03-6.38-1.05-10.35-7.24Z"
          className="cls-3har3"
        />
        <path
          d="M1076.65 1805.71c.32-1.47.77-2.93 1.35-4.38-.22 3.22.11 7.39 2 12.36 3.97 6.19 7.89 7.21 10.35 7.24 11.16.13 26.46-19.78 37.14-51.27.22-.04.46-.07.69-.1-10.68 36.11-27.59 59.45-39.67 59.3-2.46-.03-6.38-1.06-10.35-7.24-2.7-7.06-2.23-12.53-1.5-15.91Z"
          className="cls-3har2"
        />
        <path
          d="M1055.84 1870.65a2.605 2.605 0 0 1-2.5-3.36c9.59-32.09 16.72-65.85 21.2-100.35 4.09-31.48 5.98-63.72 5.63-95.82a2.612 2.612 0 0 1 2.58-2.64c1.44-.06 2.62 1.14 2.64 2.58.36 32.35-1.55 64.83-5.67 96.55-4.52 34.78-11.71 68.82-21.37 101.18a2.616 2.616 0 0 1-2.5 1.86Z"
          className="cls-3har1"
        />
        <path
          d="M1225.54 1590.55c-8.81-2.38-12.85-8.55-14.86-13.13-9.79-22.33-.36-72.97 26.3-123.17 18.32 53.73 19.21 105.47 5.88 125.86-2.71 4.15-7.85 9.8-17.33 10.45Z"
          className="cls-3har3"
        />
        <path
          d="M1251.93 1537.78c-1.29 10.5-3.5 19.13-6.54 25.18-2.14 4.26-6.12 10.11-13.25 11.17-6.54-1.98-9.42-7.94-10.81-12.41-6.03-19.33-.19-61.48 15.99-106.47-.12-.33-.23-.68-.34-1.01-26.66 50.2-36.1 100.83-26.3 123.17 2.01 4.58 6.04 10.75 14.85 13.13 9.47-.65 14.61-6.29 17.32-10.44 5.83-8.93 8.95-23.84 9.06-42.32Z"
          className="cls-3har2"
        />
        <path
          d="M1243.17 1663.48c-6.6-5.6-8.48-12.28-9.07-16.82-2.89-22.16 16.18-59.26 49.12-88.83 2.71 51.15-8.25 93.44-23.65 104.4-3.14 2.23-8.57 4.67-16.4 1.25Z"
          className="cls-3har3"
        />
        <path
          d="M1283.61 1563.05c-.56 42.28-10.61 75.63-24.03 85.19-3.14 2.24-8.57 4.67-16.4 1.25-5.5-4.67-7.72-10.08-8.64-14.39-.62 4.16-.72 8.05-.25 11.56.6 4.55 2.47 11.23 9.07 16.83 7.82 3.42 13.26.98 16.39-1.25 14.87-10.6 25.61-50.39 23.87-99.18Z"
          className="cls-3har2"
        />
        <path
          d="M1249.41 1757.13c-6.62-5.55-8.52-12.21-9.13-16.76-2.98-22.14 15.95-59.38 48.77-89.19 2.91 51.13-7.88 93.5-23.24 104.57-3.13 2.26-8.55 4.73-16.39 1.37Z"
          className="cls-3har3"
        />
        <path
          d="M1289.05 1651.17c-.44.4-.87.8-1.3 1.2-.14 43.1-10.14 77.3-23.72 87.09-3.13 2.26-8.54 4.74-16.39 1.37-3.81-3.19-6.06-6.77-7.4-10.08-.36 3.45-.36 6.66.04 9.62.62 4.54 2.52 11.2 9.14 16.76 7.84 3.35 13.26.88 16.38-1.37 15.36-11.08 26.16-53.45 23.25-104.59Z"
          className="cls-3har2"
        />
        <path
          d="M1265.34 1834.18c-6.45-5.91-8.15-12.68-8.62-17.25-2.31-22.29 17.72-58.44 51.4-86.42 1.38 51.25-10.68 92.98-26.36 103.2-3.19 2.08-8.69 4.26-16.42.46Z"
          className="cls-3har3"
        />
        <path
          d="M1308.12 1730.51c-.17.13-.33.28-.5.41-5.59 50.28-22.91 87.93-39.59 94.09-2.18.8-5.3 1.41-9.13.28 1.29 2.93 3.31 6.01 6.45 8.89 7.73 3.79 13.23 1.62 16.42-.47 15.68-10.22 27.74-51.95 26.36-103.2Z"
          className="cls-3har2"
        />
        <path
          d="M1206.28 1640.8c6.38-6.05 8-12.85 8.43-17.43 2.05-22.33-18.39-58.06-52.39-85.32-.79 51.28 11.74 92.75 27.54 102.63 3.22 2.01 8.73 4.07 16.42.12Z"
          className="cls-3har3"
        />
        <path
          d="M1214.76 1622.76c-1.26 2.61-3.12 5.29-5.81 7.85-7.68 3.95-13.21 1.89-16.42-.12-14.49-9.07-26.25-44.75-27.46-90.2-.9-.75-1.82-1.49-2.74-2.24-.78 51.27 11.75 92.75 27.54 102.63 3.21 2.01 8.73 4.07 16.42.12 6.38-6.05 8-12.85 8.43-17.43.02-.2.04-.41.05-.61Z"
          className="cls-3har2"
        />
        <path
          d="M1216.5 1716.9c4.65-8.47 4.62-15.61 3.96-20.14-3.23-22.08-30.91-47.26-69.5-58.61 11.13 49.01 32.65 83.02 49.93 85.65 3.52.54 9.23.13 15.61-6.9Z"
          className="cls-3har3"
        />
        <path
          d="M1220.46 1696.76c-.34-2.31-.95-4.67-1.81-7.02-.34 3.75-1.47 8.19-4.15 13.08-6.38 7.05-12.09 7.45-15.61 6.92-15.51-2.38-34.42-30-46.19-71.05-.58-.19-1.16-.36-1.74-.53 11.14 49.01 32.65 83.02 49.93 85.66 3.52.53 9.23.13 15.62-6.9 4.65-8.47 4.61-15.62 3.96-20.14Z"
          className="cls-3har2"
        />
        <path
          d="M1230.85 1804.96c3.88-9.16 3.21-16.25 2.16-20.64-5.15-21.39-34.85-41.9-74.16-46.91 15.37 46.85 39.72 77.12 57.11 76.94 3.54-.04 9.18-1.36 14.89-9.39Z"
          className="cls-3har3"
        />
        <path
          d="M1233 1784.32c-.46-1.9-1.11-3.81-1.94-5.68.32 4.18-.16 9.59-2.88 16.04-5.72 8.03-11.36 9.35-14.89 9.39-16.07.17-38.08-25.66-53.46-66.53-.32-.05-.66-.09-.99-.13 15.37 46.85 39.72 77.13 57.11 76.94 3.54-.04 9.18-1.37 14.89-9.39 3.88-9.17 3.21-16.26 2.16-20.65Z"
          className="cls-3har2"
        />
        <path
          d="M1262.97 1868.75c-1.5 0-2.89-.95-3.39-2.45-13.92-42.01-24.28-86.2-30.78-131.35-5.93-41.18-8.68-83.35-8.17-125.35.02-1.97 1.61-3.57 3.61-3.52 1.97.02 3.55 1.64 3.52 3.61-.51 41.63 2.21 83.43 8.09 124.24 6.44 44.73 16.7 88.51 30.5 130.13a3.567 3.567 0 0 1-3.38 4.69Z"
          className="cls-3har1"
        />
        <path
          d="M1405.07 1625.2c7.14-2.08 10.41-7.46 12.03-11.46 7.93-19.48.29-63.66-21.31-107.46-14.84 46.88-15.56 92.02-4.76 109.8 2.2 3.62 6.36 8.55 14.04 9.12Z"
          className="cls-3har3"
        />
        <path
          d="M1383.69 1579.16c1.05 9.16 2.83 16.69 5.29 21.97 1.73 3.71 4.96 8.82 10.73 9.75 5.3-1.73 7.63-6.93 8.75-10.83 4.88-16.86.15-53.64-12.95-92.89.09-.29.18-.59.28-.88 21.6 43.8 29.24 87.97 21.3 107.46-1.63 3.99-4.89 9.38-12.03 11.45-7.67-.57-11.83-5.49-14.03-9.11-4.72-7.79-7.25-20.8-7.34-36.92Z"
          className="cls-3har2"
        />
        <path
          d="M1390.79 1688.83c5.35-4.88 6.87-10.71 7.35-14.68 2.34-19.34-13.11-51.7-39.79-77.5-2.2 44.63 6.68 81.52 19.16 91.09 2.54 1.95 6.94 4.08 13.28 1.09Z"
          className="cls-3har3"
        />
        <path
          d="M1358.04 1601.2c.45 36.88 8.59 65.98 19.47 74.32 2.54 1.95 6.94 4.07 13.29 1.09 4.45-4.07 6.25-8.8 7-12.56.5 3.63.58 7.02.21 10.09-.48 3.97-2 9.8-7.35 14.68-6.33 2.98-10.74.86-13.28-1.09-12.05-9.25-20.75-43.96-19.33-86.53Z"
          className="cls-3har2"
        />
        <path
          d="M1385.74 1770.53c5.36-4.84 6.9-10.66 7.4-14.62 2.41-19.32-12.92-51.8-39.5-77.81-2.36 44.61 6.39 81.57 18.83 91.23 2.53 1.97 6.93 4.13 13.28 1.2Z"
          className="cls-3har3"
        />
        <path
          d="M1353.63 1678.09c.36.35.71.7 1.06 1.04.11 37.6 8.21 67.44 19.21 75.98 2.53 1.97 6.92 4.13 13.28 1.2 3.09-2.79 4.91-5.91 5.99-8.8.29 3.01.29 5.81-.03 8.39-.5 3.96-2.04 9.77-7.4 14.62-6.35 2.92-10.74.77-13.27-1.2-12.44-9.67-21.19-46.63-18.83-91.25Z"
          className="cls-3har2"
        />
        <path
          d="M1372.83 1837.76c5.22-5.16 6.6-11.06 6.99-15.05 1.87-19.45-14.35-50.99-41.64-75.4-1.12 44.72 8.65 81.12 21.35 90.04 2.59 1.82 7.04 3.71 13.3.41Z"
          className="cls-3har3"
        />
        <path
          d="M1338.18 1747.31c.13.12.27.24.4.36 4.53 43.87 18.56 76.71 32.07 82.09 1.77.7 4.29 1.23 7.4.24a23.176 23.176 0 0 1-5.22 7.75c-6.26 3.31-10.71 1.42-13.3-.41-12.7-8.91-22.47-45.32-21.35-90.04Z"
          className="cls-3har2"
        />
        <path
          d="M1420.67 1669.04c-5.17-5.28-6.48-11.21-6.82-15.2-1.66-19.49 14.89-50.66 42.43-74.44.64 44.74-9.51 80.92-22.31 89.54-2.61 1.76-7.07 3.55-13.3.1Z"
          className="cls-3har3"
        />
        <path
          d="M1413.81 1653.3c1.02 2.27 2.52 4.62 4.71 6.85 6.22 3.45 10.7 1.65 13.3-.1 11.74-7.92 21.26-39.04 22.25-78.7.73-.65 1.48-1.3 2.22-1.95.64 44.73-9.52 80.92-22.31 89.54-2.6 1.75-7.07 3.55-13.3.1-5.17-5.28-6.48-11.21-6.83-15.2-.02-.17-.03-.36-.04-.53Z"
          className="cls-3har2"
        />
        <path
          d="M1412.4 1735.44c-3.77-7.39-3.74-13.62-3.21-17.57 2.61-19.26 25.04-41.23 56.3-51.13-9.02 42.76-26.44 72.43-40.44 74.73-2.85.47-7.48.12-12.65-6.02Z"
          className="cls-3har3"
        />
        <path
          d="M1409.19 1717.86c.28-2.02.77-4.07 1.47-6.13.28 3.27 1.19 7.15 3.36 11.41 5.17 6.15 9.79 6.5 12.64 6.03 12.56-2.08 27.88-26.17 37.41-61.99.47-.16.94-.31 1.41-.46-9.02 42.76-26.44 72.43-40.44 74.73-2.85.46-7.48.12-12.65-6.02-3.77-7.39-3.74-13.63-3.21-17.57Z"
          className="cls-3har2"
        />
        <path
          d="M1400.77 1812.26c-3.14-7.99-2.6-14.18-1.75-18.01 4.17-18.67 28.23-36.56 60.07-40.92-12.45 40.87-32.17 67.29-46.26 67.12-2.87-.03-7.43-1.19-12.06-8.19Z"
          className="cls-3har3"
        />
        <path
          d="M1399.03 1794.26c.37-1.66.9-3.32 1.57-4.96-.26 3.64.13 8.37 2.33 14 4.63 7.01 9.2 8.16 12.06 8.19 13.02.15 30.85-22.39 43.3-58.04.26-.05.53-.08.8-.12-12.45 40.88-32.17 67.29-46.26 67.13-2.86-.03-7.44-1.2-12.06-8.19-3.14-8-2.6-14.18-1.75-18.01Z"
          className="cls-3har2"
        />
        <path
          d="M1374.76 1867.8c-.29 0-.59-.04-.88-.13a3 3 0 0 1-1.98-3.75c11.18-36.32 19.49-74.53 24.71-113.58 4.76-35.63 6.97-72.11 6.56-108.45a2.994 2.994 0 0 1 2.96-3.03c1.65.01 3.01 1.31 3.03 2.96.42 36.62-1.81 73.4-6.61 109.31-5.27 39.37-13.65 77.91-24.92 114.55a3 3 0 0 1-2.86 2.12Z"
          className="cls-3har1"
        />
        <path
          d="M1547.15 1651.74c-6.35-1.87-9.26-6.69-10.71-10.28-7.06-17.48-.26-57.11 18.96-96.41 13.21 42.06 13.85 82.55 4.24 98.51-1.96 3.25-5.66 7.67-12.49 8.18Z"
          className="cls-3har3"
        />
        <path
          d="M1566.18 1610.44c-.93 8.22-2.52 14.97-4.71 19.71-1.54 3.33-4.42 7.91-9.55 8.75-4.72-1.55-6.79-6.22-7.79-9.71-4.34-15.13-.13-48.12 11.53-83.34-.08-.26-.16-.53-.25-.79-19.22 39.29-26.02 78.92-18.96 96.4 1.45 3.58 4.35 8.41 10.71 10.28 6.83-.51 10.53-4.92 12.49-8.17 4.2-6.99 6.45-18.66 6.53-33.12Z"
          className="cls-3har2"
        />
        <path
          d="M1559.87 1708.82c-4.76-4.38-6.11-9.61-6.54-13.17-2.08-17.35 11.67-46.38 35.41-69.53 1.96 40.04-5.95 73.13-17.05 81.72-2.26 1.75-6.18 3.66-11.82.98Z"
          className="cls-3har3"
        />
        <path
          d="M1589.02 1630.22c-.4 33.09-7.65 59.19-17.33 66.68-2.26 1.75-6.18 3.65-11.83.98-3.96-3.65-5.57-7.89-6.23-11.27-.44 3.26-.52 6.3-.18 9.05.43 3.56 1.78 8.79 6.54 13.17 5.64 2.68 9.56.77 11.82-.98 10.72-8.3 18.47-39.44 17.21-77.63Z"
          className="cls-3har2"
        />
        <path
          d="M1564.36 1782.12c-4.77-4.34-6.15-9.56-6.59-13.11-2.15-17.33 11.5-46.47 35.16-69.81 2.1 40.02-5.68 73.18-16.76 81.85-2.25 1.77-6.16 3.7-11.82 1.07Z"
          className="cls-3har3"
        />
        <path
          d="M1592.94 1699.19c-.32.31-.63.62-.94.94-.1 33.73-7.31 60.5-17.1 68.17-2.25 1.77-6.16 3.71-11.82 1.07a19.89 19.89 0 0 1-5.33-7.89c-.26 2.7-.26 5.22.03 7.53.45 3.55 1.82 8.77 6.59 13.12 5.65 2.62 9.56.69 11.81-1.07 11.08-8.67 18.86-41.83 16.76-81.86Z"
          className="cls-3har2"
        />
        <path
          d="M1575.85 1842.43c-4.65-4.63-5.88-9.92-6.22-13.5-1.67-17.44 12.77-45.74 37.06-67.64.99 40.11-7.7 72.78-19 80.78-2.3 1.63-6.26 3.33-11.84.36Z"
          className="cls-3har3"
        />
        <path
          d="M1606.69 1761.29c-.12.1-.24.22-.36.32-4.03 39.36-16.52 68.82-28.55 73.64-1.58.62-3.82 1.1-6.58.22.93 2.29 2.39 4.71 4.65 6.96 5.57 2.97 9.54 1.27 11.84-.36 11.3-8 20-40.66 19-80.78Z"
          className="cls-3har2"
        />
        <path
          d="M1533.27 1691.07c4.6-4.73 5.77-10.05 6.07-13.64 1.48-17.48-13.26-45.45-37.77-66.78-.57 40.13 8.47 72.59 19.85 80.33 2.32 1.58 6.3 3.19 11.84.09Z"
          className="cls-3har3"
        />
        <path
          d="M1539.38 1676.95c-.91 2.04-2.25 4.14-4.19 6.14-5.54 3.09-9.52 1.48-11.84-.09-10.45-7.1-18.92-35.03-19.8-70.6-.65-.58-1.31-1.17-1.98-1.75-.57 40.13 8.47 72.59 19.86 80.33 2.32 1.57 6.29 3.19 11.84.09 4.6-4.74 5.77-10.06 6.08-13.64.01-.16.03-.32.04-.48Z"
          className="cls-3har2"
        />
        <path
          d="M1540.63 1750.64c3.36-6.63 3.33-12.22 2.85-15.76-2.33-17.28-22.29-36.99-50.11-45.87 8.03 38.36 23.54 64.98 36 67.04 2.54.42 6.66.11 11.26-5.4Z"
          className="cls-3har3"
        />
        <path
          d="M1543.49 1734.88c-.25-1.81-.69-3.65-1.31-5.5-.25 2.94-1.06 6.41-2.99 10.23-4.6 5.52-8.72 5.83-11.25 5.41-11.18-1.86-24.82-23.48-33.3-55.61-.42-.15-.83-.28-1.26-.42 8.03 38.36 23.54 64.98 36 67.04 2.54.42 6.65.1 11.26-5.4 3.36-6.63 3.33-12.22 2.85-15.76Z"
          className="cls-3har2"
        />
        <path
          d="M1550.98 1819.56c2.79-7.17 2.32-12.72 1.55-16.15-3.71-16.75-25.12-32.8-53.47-36.71 11.08 36.67 28.64 60.36 41.18 60.22 2.55-.03 6.62-1.07 10.74-7.35Z"
          className="cls-3har3"
        />
        <path
          d="M1552.53 1803.41c-.33-1.49-.8-2.98-1.4-4.45.23 3.27-.11 7.51-2.08 12.56-4.13 6.29-8.19 7.32-10.74 7.35-11.58.14-27.46-20.08-38.54-52.07-.23-.04-.47-.07-.71-.1 11.08 36.67 28.64 60.37 41.18 60.22 2.55-.03 6.62-1.07 10.74-7.35 2.8-7.17 2.32-12.72 1.55-16.16Z"
          className="cls-3har2"
        />
        <path
          d="M1574.14 1869.38a2.67 2.67 0 0 1-2.56-1.9c-10.03-32.87-17.5-67.44-22.18-102.76-4.27-32.22-6.25-65.21-5.88-98.06.02-1.48 1.24-2.65 2.71-2.65a2.68 2.68 0 0 1 2.65 2.71c-.37 32.6 1.6 65.33 5.84 97.29 4.65 35.03 12.05 69.31 22 101.9a2.684 2.684 0 0 1-2.56 3.47Z"
          className="cls-3har1"
        />
        {children}
      </g>
    </svg>
  );
}
